import { voiceWindows, duckFactor, DUCK_LEVEL } from "../../Utils/ducking";
import { repairVoiceAudio } from "../../Utils/voiceAudio";
import { assetUrl } from "../../Utils/assetUrl";
import { playClip } from "../../Utils/soundTrim";
import { applyLayerMotion } from "../../Utils/layerMotion";
import { React, useState, useEffect, useRef, useContext } from "react";
import PreviewCanvas from "./PreviewCanvas";
import DLoader from "../../assets/Loader/AssetLoader.json";
import Lottie from "lottie-web";
import LottiePlayer from "react-lottie-player";
import AuthContext from "../../context/userAuth.context";
import ProjectContext from "../../context/ProjectContext";
import InputRange from "react-input-range";
import MyContext from "../../context/MyContext";
var Ids = null,
  StartPoint;
var TickerPlay = null;
var checkPlaying = false;
var TempTickerPosition = 0;

const Preview = ({
  _unloadedCounter,
  UnloadedCounter,
  setUnloadedCounter,
  LoadCounter,
  setLoadCounter,
  setSupremeLayer,
  SupremeLayer,
  popupload,
  PopupWidthHeight,
  SlideBackground,
  setSlideBackground,
  setScreenSize,
  ScreenSize,
  setpopupload,
  SlideData,
  SlideTime,
  setLayersData,
  SlidesData,
  setSlidesData,
  isLoaded,
  slides,
  setslides,
  EditorZoom,
}) => {
  var Timer = 0;
  const [AnimatedBGData, setAnimatedBGData] = useState("");
  const AnimationRef = useRef(null);

  const { authenticationData } = useContext(AuthContext);
  const TickerRef = useRef(null);
  // Layers that move from A to Z (Utils/layerMotion.js) follow the preview's play position.
  const motionLayers = useRef(SlidesData);
  motionLayers.current = SlidesData;
  const { CurrentProject, watermark, bgmusicState } =
    useContext(ProjectContext);
  const [PreviewLoaded, setPreviewLoaded] = useState(true);
  const [closeclick, setcloseclick] = useState(false);
  const clone = (obj) => {
    var copy;
    if (null === obj || "object" !== typeof obj) return obj;
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  };

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    if (hrs === 0) {
      return pad(mins) + ":" + pad(secs); // + ':' + pad(Math.round(ms), 3);
    } else {
      return pad(hrs) + ":" + pad(mins) + ":" + pad(secs); // + ':' + pad(Math.round(ms), 3);
    }
  };

  const msToTime2 = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };

  function msToTime3(duration) {
    var seconds = (duration / 1000) % 60,
      minutes = Math.floor((duration / (1000 * 60)) % 60),
      minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return minutes + ":" + seconds;
  }

  const [Play, setPlay] = useState(false);

  const [DestroyPopup, setDestroyPopup] = useState(false);

  const [TickerStart, setTickerStart] = useState(true);

  const [TickerPosition, setTickerPosition] = useState(0);

  const [SliderWidth, setSliderWidth] = useState(100);

  const slideParent = useRef(null);

  const [OnePx, setOnePx] = useState(null);

  const [LayerManipulated, setLayerManipulated] = useState(false);

  const [Tl_TotalTime_Width, setTl_TotalTime_Width] = useState(0.0);

  const playBgMusicWithPreview = () => {
    try {
      if (bgmusicState.src != "") {
        var element = document.getElementById("bgmusicAudioPlayer_preview");
        element.src = authenticationData.ApiBaseURL + "/" + bgmusicState.src;
        element.volume = bgmusicState.volume / 100;
        element.currentTime = 0;
        setTimeout(function () {
          element.play();
        }, 10);
      }
    } catch (exp) {
      console.log("Error in playBgMusicWithPreview", exp);
    }
  };
  const stopBgMusicWithPreview = () => {
    try {
      if (bgmusicState.src != "") {
        var element = document.getElementById("bgmusicAudioPlayer_preview");
        element.pause();
      }
    } catch (exp) {
      console.log("Error in stopBgMusicWithPreview", exp);
    }
  };

  useEffect(() => {
    if (slideParent.current) {
      var _OnePxEquivalent = 0.0,
        _Tl_TotalTime_Width = 0.0;

      _Tl_TotalTime_Width = slides[slides.length - 1].endBackground;
      _OnePxEquivalent = slides[0].onePxEquivalent;

      // const _slides = Array.from(slides);
      // _slides.map(async (slide_value, index) => {
      //   if (slide_value.onePxEquivalent) {
      //     _OnePxEquivalent = slide_value.onePxEquivalent;
      //     if (slide_value.endBackground >= _Tl_TotalTime_Width) {
      //       _Tl_TotalTime_Width = slide_value.endBackground;
      //     }
      //   }
      // });

      const array = Array.from(SlidesData);

      repairVoiceAudio(array, authenticationData.ApiBaseURL);
      let change = false;
      array.map((value) => {
        if (value.type === "Character") {
          var _find_Talk_Month = value.JSONValue?.assets[1]?.layers?.find(
            (x) => x.nm === "Mouth_Talk"
          );

          if (!_find_Talk_Month && value.JSONValue) {
            if (value.JSONValue.assets.find((x) => x.nm == "Mouth_Comp")) {
              _find_Talk_Month = value.JSONValue.assets
                .find((x) => x.nm == "Mouth_Comp")
                .layers.find((y) => y.nm == "Mouth_Talk");
            } else if (value.JSONValue.assets.find((x) => x.id == "comp_11")) {
              _find_Talk_Month = value.JSONValue.assets
                .find((x) => x.id == "comp_11")
                .layers.find((y) => y.nm == "Mouth_Talk");
            }
          }

          if (_find_Talk_Month) {
            if (!_find_Talk_Month.hd) {
              stopTalking(value.JSONValue, value);
              change = true;
            }
          }
        }

        if (value.type === "basicShape") {
          // const _basicShape = document.getElementById("default-shape-" + value.key);

          // if(_basicShape)
          // {
          //     _basicShape.style.transform = `rotate(${value.rotateAngle}deg)`;
          // }

          if (PreviewLoaded) {
            setTimeout(() => {
              // setPlay(true)
              Check(0);
              setPreviewLoaded(false);
            }, 1200);
          }
        }
        if (value.type === "Shape") {
          if (PreviewLoaded) {
            setTimeout(() => {
              // setPlay(true)
              Check(0);
              setPreviewLoaded(false);
            }, 1200);
          }
        }

        if (value.type === "AnimatedText") {
          if (PreviewLoaded) {
            setTimeout(() => {
              // setPlay(true)
              Check(0);
              setPreviewLoaded(false);
            }, 1200);
          }
        }

        if (value.type === "audio") {
          if (PreviewLoaded) {
            setTimeout(() => {
              // setPlay(true)
              Check(0);
              setPreviewLoaded(false);
            }, 1200);
          }
        }

        if (value.type === "text") {
          if (PreviewLoaded) {
            setTimeout(() => {
              // setPlay(true)
              Check(0);
              setPreviewLoaded(false);
            }, 1200);
          }
        }

        if (value.isPlaying) {
          value.isPlaying = false;
          change = true;
        }

        if (value.player) {
          value.player = false;
          change = true;
        }
      });

      if (change) {
        setSlidesData(array);
      }

      setOnePx(_OnePxEquivalent);
      let width = slideParent.current.offsetWidth * 0.8;
      if (TickerRef.current) {
        TickerRef.current.value = 0;
      }
      setSliderWidth(width);

      if (isLoaded) {
        if (_Tl_TotalTime_Width === 0) {
          setTl_TotalTime_Width(width);
        } else {
          setTl_TotalTime_Width(_Tl_TotalTime_Width);
        }

        setTimeout(() => {
          // setPlay(true)
          Check(0);
          setPreviewLoaded(false);
        }, 1200);
      } else {
        if (_Tl_TotalTime_Width === 0) {
          setTl_TotalTime_Width(width);
        } else {
          setTl_TotalTime_Width(_Tl_TotalTime_Width);
        }
      }

      setLayerManipulated(true);
    }
  }, [slideParent.current]);

  let start, previousTimeStamp;
  const [onplayticker, setonplayticker] = useState(0);

  useEffect(() => {
    if (!PreviewLoaded) {
      if (!Play) {
        setTimeout(() => {
          setPlay(true);
          playBgMusicWithPreview();
        }, 500);
      }
    } else {
      if (Play) {
        setPlay(false);
      }
    }
  }, [PreviewLoaded]);

  // function step(timestamp) {

  //     if (start === null) {
  //         start = timestamp;
  //         StartPoint = TickerPosition;
  //     }
  //     var elapsed = timestamp - start;
  //     if (previousTimeStamp !== timestamp) {
  //         const calc = StartPoint + elapsed / OnePx
  //         let string = JSON.stringify(calc)
  //         string = string.split('.')[0]

  //         // if(isNaN(calc))
  //         // {   const count = 0;
  //         //     TickerPlay = count
  //         //     setonplayticker(count)
  //         //     //TempTickerPosition = count
  //         //     setTickerPosition(count)
  //         //     Check(count)
  //         // }
  //         // else
  //         if (eval(string) !== TickerPlay) {
  //             // const count = Math.min(string, SliderWidth);
  //             const count = Math.min(string, Tl_TotalTime_Width);
  //             TickerPlay = count
  //             setonplayticker(count)
  //             //TempTickerPosition = count
  //             setTickerPosition(count)
  //             Check(count)
  //         }
  //     }

  //     let ms = OnePx * Tl_TotalTime_Width - OnePx * StartPoint
  //     // let ms = (OnePx * Tl_TotalTime_Width) - (OnePx * Tl_TotalTime_Width)
  //     if (elapsed < ms) {
  //         if (Ids !== null) {
  //             previousTimeStamp = timestamp
  //             const id = window.requestAnimationFrame(step);
  //             Ids = id
  //         }
  //     } else {

  //         window.cancelAnimationFrame(Ids);
  //         // setTickerPosition(onplayticker)
  //         Ids = null
  //         setPlay(false)
  //         start = null;
  //     }
  // }

  function step(timestamp) {
    if (start === null) {
      start = timestamp;
      StartPoint = TickerPosition;
    }
    var elapsed = timestamp - start;

    if (previousTimeStamp !== timestamp) {
      const calc = StartPoint + elapsed / OnePx;
      let string = JSON.stringify(calc);
      string = string.split(".")[0];
      if (eval(string) !== TickerPlay) {
        const count = Math.min(string, Tl_TotalTime_Width);

        if (TickerRef.current) TickerRef.current.value = count;
        setinputTickerVal(count);

        TickerPlay = count;

        Check(count);
        applyLayerMotion(motionLayers.current, count * OnePx, OnePx, "Preview-", authenticationData.ApiBaseURL);
        // Lower music while characters speak (Utils/ducking.js).
        {
          const _windows = voiceWindows(motionLayers.current, OnePx, 0);
          const _sec = (count * OnePx) / 1000;
          window.__toonsDuckFactor = duckFactor(_windows, _sec, DUCK_LEVEL);
          const _bg = document.getElementById("bgmusicAudioPlayer_preview");
          if (_bg && bgmusicState && bgmusicState.src && bgmusicState.duck) {
            _bg.volume = Math.min(1, Math.max(0, ((Number(bgmusicState.volume) || 0) / 100) * duckFactor(_windows, _sec, bgmusicState.duck)));
          }
        }
        //console.log("TickerPosition",TickerPosition);
        //console.log("Count",count);
      }
    }

    let ms = OnePx * Tl_TotalTime_Width - OnePx * StartPoint;
    if (elapsed < ms) {
      if (Ids != null) {
        previousTimeStamp = timestamp;
        const id = window.requestAnimationFrame(step);
        Ids = id;
      }
    } else {
      window.cancelAnimationFrame(Ids);
      Ids = null;
      //   setCanvasDisplay(true);
      start = null;
    }
  }

  //Whole function is commented as this does not apply for preview because its only for dragging the ticker.

  // function mtrans(val) {

  //   if (Play) {
  //     setPlay(false);
  //   }

  //   let check = false;
  //   const array = Array.from(SlidesData);

  //   // let ms = (slideParent.current.scrollLeft + LastX) //* onePxEquivalent;
  //   // setLastX(val)

  //   // if (ms >= 0) {

  //   //     Timer = ms;
  //   // } else {
  //   //     Timer = 0;
  //   // }

  //   if (array.length > 0) {
  //     array.forEach((element) => {
  //       if (element.type == "Character" && element.TTSName !== "") {
  //         element.isTickerMove = val;
  //         element.is_mtrans_call = true;
  //         Check(val);
  //         element.isPlaying = false;
  //       }
  //     });
  //   } else {
  //     Check(val);
  //   }
  //   // setTickerPosition(val);
  //   setonplayticker(val);

  //   for (let i = 0; i < array.length; i++) {
  //     array[i].abc = "yes";
  //     let aToZStart = array[i].startPositionOnTimeline;
  //     if (val < aToZStart) {
  //       if (array[i].originalX) {
  //         array[i].x = array[i].originalX;
  //       }
  //       if (array[i].originalY) {
  //         array[i].y = array[i].originalY;
  //       }
  //       if (array[i].originalWidth) {
  //         array[i].width = array[i].originalWidth;
  //       }
  //       if (array[i].originalHeight) {
  //         array[i].height = array[i].originalHeight;
  //       }
  //       if (array[i].originalOpacity) {
  //         array[i].opacity = array[i].originalOpacity;
  //       }
  //       if (array[i].originalRotateAngle) {
  //         array[i].rotateAngle = array[i].originalRotateAngle;
  //       }
  //       if (array[i].originalFontSize) {
  //         if (array[i].type == "text") {
  //           array[i].fontSize = array[i].originalFontSize;
  //         }
  //       }
  //       if (
  //         array[i].type == "text" &&
  //         array[i].InEffect === "animated WordByWordFade "
  //       ) {
  //         var txt = array[i].originalText;
  //         var StrCounter = array[i].WordsArray.length + 1;

  //         let tickerPositionInEffect = val - array[i].startPositionOnTimeline;
  //         let divider = array[i].startTransitionWidth / StrCounter;
  //         let appendIndex = parseInt(tickerPositionInEffect / divider);
  //         let _opacity = (tickerPositionInEffect / divider) % 1;
  //         let $el = document.getElementById(array[i].TextId);
  //         $el.innerHTML = "";
  //         for (const j of array[i].WordsArray) {
  //           let span = document.createElement("span");
  //           span.style.opacity = 0;
  //           span.id = j.id;
  //           if (j.word == "") {
  //             span.style.opacity = 1;
  //             span.setAttribute("data-empty", "1");
  //           }
  //           span.innerHTML = j.word + j.next;
  //           $el.appendChild(span);
  //         }

  //         for (let j = 0; j < appendIndex - 1; j++) {
  //           let span = document.getElementById(array[i].WordsArray[j].id);
  //           if (j == appendIndex - 2) {
  //             span.style.opacity = _opacity;
  //           } else {
  //             span.style.opacity = 1;
  //           }
  //         }
  //       }
  //     } else {
  //       if (array[i].OutEffect !== "none") {
  //         if (array[i].OutEffect === "animated slideOutLeft ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let diff = array[i].width / array[i].endTransitionWidth;
  //             let TickerIncr = val - grandWidth;
  //             array[i].x = array[i].originalX - diff * TickerIncr;
  //             check = true;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated slideOutRight ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let diff = array[i].width / array[i].endTransitionWidth;
  //             let TickerIncr = val - grandWidth;
  //             array[i].x = array[i].originalX + diff * TickerIncr;
  //             check = true;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated slideOutUp ") {
  //           var totalwidth = array[i].originalX - array[i].height;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let diff = array[i].height / array[i].endTransitionWidth;
  //             let TickerIncr = val - grandWidth;
  //             array[i].y = array[i].originalY - diff * TickerIncr;
  //             check = true;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated slideOutDown ") {
  //           var totalwidth = array[i].originalX + array[i].height;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let diff = array[i].height / array[i].endTransitionWidth;
  //             let TickerIncr = val - grandWidth;
  //             array[i].y = array[i].originalY + diff * TickerIncr;
  //             check = true;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated slideOutDown ") {
  //           var totalwidth = array[i].originalX + array[i].height;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let diff = array[i].height / array[i].endTransitionWidth;
  //             let TickerIncr = val - grandWidth;
  //             array[i].y = array[i].originalY + diff * TickerIncr;
  //             check = true;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated fadeOut ") {
  //           var totalwidth = array[i].originalX + array[i].height;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (
  //             grandWidth <= val &&
  //             array[i].startPositionOnTimeline + array[i].widthOnTimeline >= val
  //           ) {
  //             let TickerIncr = val - grandWidth;
  //             let opacityPercentage =
  //               1 - TickerIncr / array[i].endTransitionWidth;
  //             array[i].opacity = opacityPercentage;
  //             check = true;
  //           } else {
  //             array[i].opacity = array[i].originalOpacity;
  //           }
  //         }
  //         if (array[i].OutEffect === "animated zoomOut ") {
  //           var totalwidth = array[i].originalX + array[i].height;
  //           let grandWidth =
  //             array[i].startPositionOnTimeline +
  //             (array[i].widthOnTimeline - array[i].endTransitionWidth);
  //           if (grandWidth <= val) {
  //             let TickerIncr = val - grandWidth;

  //             let percentage = 1 - TickerIncr / array[i].endTransitionWidth;
  //             if (percentage >= 0) {
  //               array[i].width = percentage * array[i].originalWidth;
  //               array[i].height = percentage * array[i].originalHeight;
  //               array[i].x =
  //                 array[i].originalX +
  //                 (array[i].originalWidth - array[i].width) / 2;
  //               array[i].y =
  //                 array[i].originalY +
  //                 (array[i].originalHeight - array[i].height) / 2;
  //               if (array[i].type == "text") {
  //                 array[i].fontSize = parseInt(
  //                   array[i].originalFontSize * percentage
  //                 );
  //               }
  //             }
  //             check = true;
  //           }
  //         }
  //       }
  //       if (array[i].InEffect !== "none") {
  //         aToZStart =
  //           array[i].startPositionOnTimeline + array[i].startTransitionWidth;
  //         if (array[i].InEffect === "animated TypeWriterr ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             if (val - array[i].startPositionOnTimeline > 0) {
  //               var txt = array[i].originalText;
  //               var StrCounter = txt.length + 1;

  //               let tickerPositionInEffect =
  //                 val - array[i].startPositionOnTimeline;
  //               let divider = array[i].startTransitionWidth / StrCounter;
  //               let appendIndex = parseInt(tickerPositionInEffect / divider);
  //               let str = "";
  //               for (let j = 0; j < appendIndex - 1; j++) {
  //                 if (
  //                   txt.charAt(j) == "<" &&
  //                   txt.charAt(j + 1).toLowerCase() == "b" &&
  //                   txt.charAt(j + 2).toLowerCase() == "r" &&
  //                   txt.charAt(j + 3).toLowerCase() == ">"
  //                 ) {
  //                   str += "<br>";
  //                   j = j + 4;
  //                 } else if (
  //                   txt.charAt(j) == "&" &&
  //                   txt.charAt(j + 1).toLowerCase() == "n" &&
  //                   txt.charAt(j + 2).toLowerCase() == "b" &&
  //                   txt.charAt(j + 3).toLowerCase() == "s" &&
  //                   txt.charAt(j + 4).toLowerCase() == "p" &&
  //                   txt.charAt(j + 5).toLowerCase() == ";"
  //                 ) {
  //                   str += "&nbsp;";
  //                   j = j + 6;
  //                 } else {
  //                   str += txt.charAt(j);
  //                 }
  //               }
  //               array[i].text = str;
  //             }
  //             check = true;
  //           }
  //         }
  //         if (
  //           (array[i].InEffect === "animated TextBounce " ||
  //             array[i].InEffect === "animated TypeWriter ") &&
  //           !Play
  //         ) {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             if (val - array[i].startPositionOnTimeline > 0) {
  //               var txt = array[i].originalText;
  //               var StrCounter = txt.length + 1;

  //               let tickerPositionInEffect =
  //                 val - array[i].startPositionOnTimeline;
  //               let divider = array[i].startTransitionWidth / StrCounter;
  //               let appendIndex = parseInt(tickerPositionInEffect / divider);
  //               let $el = document.getElementById(array[i].TextId);
  //               if ($el) {
  //                 $el.innerHTML = "";
  //                 for (let j = 0; j < array[i].CharactersArray.length; j++) {
  //                   let obj = array[i].CharactersArray[j];
  //                   if (obj) {
  //                     let span = document.createElement("span");
  //                     span.id = obj.id;
  //                     if (j < appendIndex - 1) {
  //                       span.style.opacity = 1;
  //                       span.setAttribute("data-doneBounce", 1);
  //                     } else {
  //                       span.style.opacity = 0;
  //                     }
  //                     if (obj.character == "") {
  //                       span.style.opacity = 1;
  //                       span.setAttribute("data-empty", "1");
  //                     } else {
  //                       span.style.position = "relative";
  //                     }
  //                     span.innerHTML = obj.character + obj.next;
  //                     $el.appendChild(span);
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //         if (array[i].InEffect === "animated WordByWordFade ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             if (val - array[i].startPositionOnTimeline > 0) {
  //               var txt = array[i].originalText;
  //               var StrCounter = array[i].WordsArray.length + 1;

  //               let tickerPositionInEffect =
  //                 val - array[i].startPositionOnTimeline;
  //               let divider = array[i].startTransitionWidth / StrCounter;
  //               let appendIndex = parseInt(tickerPositionInEffect / divider);
  //               let _opacity = (tickerPositionInEffect / divider) % 1;
  //               let $el = document.getElementById(array[i].TextId);
  //               $el.innerHTML = "";
  //               for (const j of array[i].WordsArray) {
  //                 let span = document.createElement("span");
  //                 span.style.opacity = 0;
  //                 span.id = j.id;
  //                 if (j.word == "") {
  //                   span.style.opacity = 1;
  //                   span.setAttribute("data-empty", "1");
  //                 }
  //                 span.innerHTML = j.word + j.next;
  //                 $el.appendChild(span);
  //               }

  //               for (let j = 0; j < appendIndex - 1; j++) {
  //                 let span = document.getElementById(array[i].WordsArray[j].id);
  //                 if (j == appendIndex - 2) {
  //                   span.style.opacity = _opacity;
  //                 } else {
  //                   span.style.opacity = 1;
  //                 }
  //               }
  //             }
  //           }
  //         }
  //         if (array[i].InEffect === "animated WordByWordAppear ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             if (val - array[i].startPositionOnTimeline > 0) {
  //               var txt = array[i].originalText;

  //               var StrCounter = array[i].WordsArray.length + 1;

  //               let tickerPositionInEffect =
  //                 val - array[i].startPositionOnTimeline;
  //               let divider = array[i].startTransitionWidth / StrCounter;
  //               let appendIndex = parseInt(tickerPositionInEffect / divider);

  //               let _opacity = (tickerPositionInEffect / divider) % 1;
  //               let $el = document.getElementById(array[i].TextId);
  //               $el.innerHTML = "";
  //               for (const j of array[i].WordsArray) {
  //                 let span = document.createElement("span");
  //                 span.style.opacity = 0;
  //                 span.id = j.id;
  //                 if (j.word == "") {
  //                   span.style.opacity = 1;
  //                   span.setAttribute("data-empty", "1");
  //                 } else {
  //                   span.style.position = "absolute";
  //                   span.style.color = "transparent";
  //                   span.style.textShadow = `0 0 10px ${array[i].textColor}`;
  //                   span.style.fontSize = array[i].fontSize + 10 + "px";
  //                 }
  //                 span.innerHTML = " " + j.word + j.next;
  //                 $el.appendChild(span);
  //               }

  //               for (let j = 0; j < appendIndex - 1; j++) {
  //                 let span = document.getElementById(array[i].WordsArray[j].id);
  //                 span.style.opacity = 1;
  //                 if (j == appendIndex - 2) {
  //                   //span.style.opacity = _opacity;

  //                   let fontSize =
  //                     Number(span.style.fontSize.split("px")[0]) -
  //                     _opacity * 10;
  //                   let textShadow = 10 - _opacity * 10;
  //                   span.style.fontSize = fontSize + "px";
  //                   span.style.textShadow = `0 0 ${textShadow}px ${array[i].textColor}`;
  //                 } else {
  //                   span.style.position = "";
  //                   span.style.fontSize = "";
  //                   span.style.textShadow = "";
  //                   span.style.color = "";
  //                   span.innerHTML = span.innerHTML.split(" ")[1] + " ";
  //                 }
  //               }
  //             }
  //           }
  //         }
  //         if (array[i].InEffect === "animated slideInRight ") {
  //           var totalwidth = array[i].originalX + array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             let diff = totalwidth - array[i].originalX;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             array[i].x = totalwidth - startpoint * diff;
  //             check = true;
  //           }
  //         }
  //         if (array[i].InEffect === "animated slideInLeft ") {
  //           //totalwidth is position from where it should start animating
  //           // var totalwidth =
  //           //   array[i].originalX -
  //           //   document.getElementsByClassName("video-preview")[0].clientWidth;
  //           //var totalwidth = array[i].originalX - array[i].width;
  //           var totalwidth = 0 - array[i].width;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             let diff = totalwidth - array[i].originalX;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             array[i].x = Math.abs(startpoint * diff) + totalwidth;
  //             check = true;
  //           }
  //         }
  //         if (array[i].InEffect === "animated slideInDown ") {
  //           var totalHeight = array[i].originalY - array[i].height;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             let diff = totalHeight - array[i].originalY;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             array[i].y = Math.abs(startpoint * diff) + totalHeight;
  //             check = true;
  //           }
  //         }
  //         if (array[i].InEffect === "animated slideInUp ") {
  //           var totalHeight = array[i].originalY + array[i].height;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //               val &&
  //             val >= array[i].startPositionOnTimeline
  //           ) {
  //             let diff = totalHeight - array[i].originalY;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             array[i].y = totalHeight - startpoint * diff;
  //             check = true;
  //           }
  //         }
  //         if (array[i].InEffect === "animated fadeIn ") {
  //           var totalHeight = array[i].originalX + array[i].height;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             let diff = totalHeight - array[i].originalY;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             let opacityPercentage =
  //               startpoint / array[i].startTransitionWidth;
  //             array[i].opacity = opacityPercentage;
  //             check = true;
  //           }
  //         }
  //         if (array[i].InEffect === "animated zoomIn ") {
  //           var totalHeight = array[i].originalX + array[i].originalHeight;
  //           if (
  //             array[i].startPositionOnTimeline +
  //               array[i].startTransitionWidth >=
  //             val
  //           ) {
  //             let diff = totalHeight - array[i].originalY;
  //             diff = diff / array[i].startTransitionWidth;
  //             let startpoint = val - array[i].startPositionOnTimeline;
  //             let percentage = startpoint / array[i].startTransitionWidth;
  //             if (percentage >= 0) {
  //               array[i].width = percentage * array[i].originalWidth;
  //               array[i].height = percentage * array[i].originalHeight;
  //               array[i].x =
  //                 array[i].originalX +
  //                 (array[i].originalWidth - array[i].width) / 2;
  //               array[i].y =
  //                 array[i].originalY +
  //                 (array[i].originalHeight - array[i].height) / 2;
  //               if (array[i].type == "text") {
  //                 array[i].fontSize = parseInt(
  //                   array[i].originalFontSize * percentage
  //                 );
  //               }
  //             }
  //             check = true;
  //           }
  //         }
  //       }
  //       // if (array[i].AzData) {
  //       //     if (val >= aToZStart && val <= array[i].AzData.widthOnTimeline + aToZStart) {
  //       //         let tickerStartpoint = val - aToZStart; // array[i].startPositionOnTimeline// + array[i].tranistionStartpoint;
  //       //         let aToZEnd = array[i].AzData.widthOnTimeline + aToZStart
  //       //         let azData = array[i].AzData;
  //       //         let totalTime = aToZEnd - aToZStart;
  //       //         let timePercentage = tickerStartpoint / totalTime;

  //       //         if (azData.x != array[i].originalX) {
  //       //             if (azData.x > array[i].originalX) {
  //       //                 let totalXPath = azData.x - array[i].originalX;
  //       //                 let xPercentage = timePercentage * totalXPath; //azData.x;
  //       //                 array[i].x = array[i].originalX + xPercentage;
  //       //             }
  //       //             else {
  //       //                 let totalXPath = array[i].originalX - azData.x;
  //       //                 let xPercentage = timePercentage * totalXPath; //azData.x;
  //       //                 array[i].x = array[i].originalX - xPercentage;
  //       //             }
  //       //         }
  //       //         if (azData.y != array[i].originalY) {
  //       //             if (azData.y > array[i].originalY) {
  //       //                 let totalYPath = azData.y - array[i].originalY;
  //       //                 let yPercentage = timePercentage * totalYPath; // azData.y;
  //       //                 array[i].y = array[i].originalY + yPercentage;
  //       //             }
  //       //             else {
  //       //                 let totalYPath = array[i].originalY - azData.y;
  //       //                 let yPercentage = timePercentage * totalYPath; // azData.y;
  //       //                 array[i].y = array[i].originalY - yPercentage;
  //       //             }
  //       //         }
  //       //         if (azData.width != array[i].originalWidth) {
  //       //             if (azData.width > array[i].originalWidth) {
  //       //                 let totalWidthPath = azData.width - array[i].originalWidth;
  //       //                 let widthPercentage = timePercentage * totalWidthPath; // azData.y;
  //       //                 array[i].width = array[i].originalWidth + widthPercentage;
  //       //             }
  //       //             else {
  //       //                 let totalWidthPath = array[i].originalWidth - azData.width;
  //       //                 let widthPercentage = timePercentage * totalWidthPath; // azData.y;
  //       //                 array[i].width = array[i].originalWidth - widthPercentage;
  //       //             }
  //       //         }
  //       //         if (azData.height != array[i].originalHeight) {
  //       //             if (azData.height > array[i].originalHeight) {
  //       //                 let totalHeightPath = azData.height - array[i].originalHeight;
  //       //                 let heightPercentage = timePercentage * totalHeightPath; // azData.y;
  //       //                 array[i].height = array[i].originalHeight + heightPercentage;
  //       //             }
  //       //             else {
  //       //                 let totalHeightPath = array[i].originalHeight - azData.height;
  //       //                 let heightPercentage = timePercentage * totalHeightPath; // azData.y;
  //       //                 array[i].height = array[i].originalHeight - heightPercentage;
  //       //             }
  //       //         }
  //       //         if (azData.rotateAngle != array[i].originalRotateAngle) {
  //       //             let AzAngle;
  //       //             if (azData.rotateAngle > 180) {
  //       //                 AzAngle = azData.rotateAngle - 360
  //       //             } else {
  //       //                 AzAngle = azData.rotateAngle
  //       //             }
  //       //             let Angle;
  //       //             if (array[i].originalRotateAngle > 180) {
  //       //                 Angle = array[i].originalRotateAngle - 360
  //       //             }
  //       //             else {
  //       //                 Angle = array[i].originalRotateAngle
  //       //             }

  //       //             if (AzAngle > Angle) {
  //       //                 let totalrotateAnglePath = AzAngle - Angle;
  //       //                 let rotatePercentage = timePercentage * totalrotateAnglePath; // azData.y;
  //       //                 array[i].rotateAngle = Angle + rotatePercentage;
  //       //             }
  //       //             else {
  //       //                 let totalrotateAnglePath = Angle - AzAngle;
  //       //                 let rotatePercentage = timePercentage * totalrotateAnglePath; // azData.y;
  //       //                 array[i].rotateAngle = Angle - rotatePercentage;
  //       //             }
  //       //         }
  //       //     } else {
  //       //         if (array[i].x != array[i].AzData.x || array[i].y != array[i].AzData.y || array[i].width != array[i].AzData.width ||
  //       //             array[i].height != array[i].AzData.height || array[i].rotateAngle != array[i].AzData.rotateAngle) {
  //       //             array[i].x = array[i].AzData.x;
  //       //             array[i].y = array[i].AzData.y;
  //       //             array[i].width = array[i].AzData.width;
  //       //             array[i].height = array[i].AzData.height;
  //       //             array[i].rotateAngle = array[i].AzData.rotateAngle;
  //       //         }
  //       //     }
  //       // }
  //     }

  //     if (
  //       array[i].type == "text" &&
  //       array[i].InEffect === "animated TypeWriterr "
  //     ) {
  //       if (val < array[i].startPositionOnTimeline) {
  //         document.getElementById(array[i].TextId).innerHTML = "";
  //       }
  //     } else if (
  //       array[i].type == "text" &&
  //       (array[i].InEffect === "animated WordByWordFade " ||
  //         array[i].InEffect === "animated WordByWordAppear ")
  //     ) {
  //       if (val < array[i].startPositionOnTimeline) {
  //         if (!array[i].draggedBeforeStartPos) {
  //           array[i].text = "";
  //           array[i].draggedBeforeStartPos = true;
  //           check = true;
  //         }
  //       } else {
  //         if (array[i].draggedBeforeStartPos) {
  //           array[i].draggedBeforeStartPos = false;
  //           check = true;
  //         }
  //       }
  //     }
  //   }

  //   if (check) {
  //     setSlidesData(array);
  //     // setSupremeLayer({ ...SupremeLayer, Layer: array });
  //   }
  // }

  useEffect(async () => {
    if (Play) {
      console.log("started preview 2");
      checkPlaying = true;
      // if (SliderWidth > TickerPosition) {
      if (Tl_TotalTime_Width > TickerPosition) {
        start = null;
        TickerPlay = TickerPosition;
        // setonplayticker(TickerPosition)

        const id = window.requestAnimationFrame(step);
        Ids = id;
      }
    } else if (!Play) {
      //setTickerPosition(TempTickerPosition)
      // setTickerPosition(onplayticker)
      console.log("ended preview");
      stopBgMusicWithPreview();
      if (TickerRef.current) {
        setTickerPosition(parseFloat(TickerRef.current.value));
      }
      checkPlaying = false;
      start = null;

      if (TickerPosition !== Tl_TotalTime_Width) {
        const array = Array.from(SlidesData);
        repairVoiceAudio(array, authenticationData.ApiBaseURL);
        for (let i = 0; i < array.length; i++) {
          if (array[i].player) {
            // array[i].player = false

            //console.log("a");
            array[i].isHide = true;

            if (array[i].type === "Character") {
              if (array[i].Audio) {
                if (array[i].Audio.paused !== undefined) {
                  array[i].Audio.pause();
                }
              }
            }
          }

          if (array[i].type === "Props") {
            var val = await ForEmergencyLottiePlayer(array[i]);
            if (val) val.goToAndStop(0, true);
          }

          if (array[i].type === "Video") {
            const _video = document.getElementById("VideosDiv-" + array[i].AnimationId);
            if (_video) _video.pause();
          }

          if (array[i].startAtoZ) {
            array[i].startAtoZ = false;
          }
          if (array[i].Animate) {
            array[i].Animate = false;
          }
          array[i].StartAudioTime = 0;
          array[i].isPlaying = false;
        }

        // setSlidesData(array)
      }

      // setSupremeLayer({ ...SupremeLayer, Layer: array })

      // mtrans(width)

      if (Ids !== null) {
        window.cancelAnimationFrame(Ids);
        Ids = null;
      }
    }
  }, [Play]);

  useEffect(() => {
    if (OnePx) {
      let backgronds = Array.from(SlideBackground);

      backgronds.map((value, index) => {
        value.time = value.time / OnePx;
      });

      // for (let i = 0; i < backgronds.length; i++) {
      //     backgronds[i].time = backgronds[i].time / OnePx;
      // }
      setSlideBackground(backgronds);
      //resetFancyTextEffects()
    }
  }, [OnePx]);

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat((width * OnePx).toFixed(3));
    return msToTime(ms);
  };

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const calculateWidthByDuration = (duration) => {
    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds / OnePx); //onePxEquivalent
  };

  function resetFancyTextEffects() {
    const array = Array.from(SlidesData);
    repairVoiceAudio(array, authenticationData.ApiBaseURL);
    for (let i = 0; i < array.length; i++) {
      let types = array[i].InEffect;

      if (
        types == "animated TextBounce " ||
        types == "animated Rolling " ||
        types == "animated TypeWriter "
      ) {
        var txt = array[i].text;
        let charactersArray = [];
        let cleanCharacterArray = [];
        let character = "";
        let calculatedTime = 0;

        for (let j = 0; j < txt.length; j++) {
          if (
            txt.charAt(j) == "<" &&
            txt.charAt(j + 1).toLowerCase() == "b" &&
            txt.charAt(j + 2).toLowerCase() == "r" &&
            txt.charAt(j + 3).toLowerCase() == ">"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              character: character,
              next: "<br>",
              startAt: calculatedTime,
            };
            if (character != "") {
              calculatedTime += 40;
              cleanCharacterArray.push(obj);
            }
            charactersArray.push(obj);
            character = "";
            j = j + 3;
          } else if (
            txt.charAt(j) == "&" &&
            txt.charAt(j + 1).toLowerCase() == "n" &&
            txt.charAt(j + 2).toLowerCase() == "b" &&
            txt.charAt(j + 3).toLowerCase() == "s" &&
            txt.charAt(j + 4).toLowerCase() == "p" &&
            txt.charAt(j + 5).toLowerCase() == ";"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              character: character,
              next: "&nbsp;",
              startAt: calculatedTime,
            };
            if (character != "") {
              calculatedTime += 40;
              cleanCharacterArray.push(obj);
            }
            charactersArray.push(obj);
            character = "";
            j = j + 5;
          } else if (txt.charAt(j) == " ") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              character: character,
              next: " ",
              startAt: calculatedTime,
            };
            if (character != "") {
              calculatedTime += 40;
              cleanCharacterArray.push(obj);
            }
            charactersArray.push(obj);
            character = "";
            // j = j + 6;
          } else {
            if (character != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                character: character,
                next: "",
                startAt: calculatedTime,
              };
              if (character != "") {
                calculatedTime += 40;
                cleanCharacterArray.push(obj);
              }
              charactersArray.push(obj);
            }
            character = txt.charAt(j);
          }
        }

        if (character != "") {
          let obj = {
            id: `wbwf_${makeid(8)}`,
            character: character,
            next: "",
            startAt: calculatedTime,
          };
          if (character != "") {
            calculatedTime += 40;
            cleanCharacterArray.push(obj);
          }
          charactersArray.push(obj);
        }
        array[i].CharactersArray = charactersArray;
        array[i].cleanCharacterArray = cleanCharacterArray;

        array[i].startTransitionWidth = calculateWidthByDuration(
          msToTime2(calculatedTime)
        );
        let minMsPrLetter =
          totalTimeToMs(calculateTimeByWidth(array[i].startTransitionWidth)) /
          cleanCharacterArray.length;
        if (
          array[i].startTransitionWidth >
          Number(TickerRef.current.max) - array[i].endTransitionWidth
        ) {
          minMsPrLetter =
            totalTimeToMs(
              calculateTimeByWidth(
                Number(TickerRef.current.max) - array[i].endTransitionWidth
              )
            ) / cleanCharacterArray.length;
          array[i].startTransitionWidth =
            Number(TickerRef.current.max) - array[i].endTransitionWidth; //calculateWidthByDuration(msToTime2(calculatedTime));
        }
        array[i].bounceInMs = minMsPrLetter;
        if (minMsPrLetter < 20) {
          alert("can not set transition: " + minMsPrLetter);
        }
      } else if (types == "animated WordByWordFade ") {
        var txt = array[i].text;
        let wordsArray = [];
        let cleanWordsArray = [];
        let word = "";
        let CalculatedTime = 0;
        let opacityIncrement = 0.03;
        let perWordFPS = 60;
        let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
        let perWordMS = 200;

        for (let j = 0; j < txt.length; j++) {
          if (
            txt.charAt(j) == "<" &&
            txt.charAt(j + 1).toLowerCase() == "b" &&
            txt.charAt(j + 2).toLowerCase() == "r" &&
            txt.charAt(j + 3).toLowerCase() == ">"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "<br>",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            j = j + 3;
          } else if (
            txt.charAt(j) == "&" &&
            txt.charAt(j + 1).toLowerCase() == "n" &&
            txt.charAt(j + 2).toLowerCase() == "b" &&
            txt.charAt(j + 3).toLowerCase() == "s" &&
            txt.charAt(j + 4).toLowerCase() == "p" &&
            txt.charAt(j + 5).toLowerCase() == ";"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "&nbsp;",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            j = j + 5;
          } else if (txt.charAt(j) == " ") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: " ",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            // j = j + 6;
          } else {
            word += txt.charAt(j);
          }
        }
        if (word != "") {
          let obj = {
            id: `wbwf_${makeid(8)}`,
            word: word,
            next: "",
            startAt: CalculatedTime,
          };
          if (word != "") {
            CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
            cleanWordsArray.push(obj);
          }
          wordsArray.push(obj);
          word = "";
        }

        array[i].WordsArray = wordsArray;
        array[i].startTransitionWidth = calculateWidthByDuration(
          msToTime2(CalculatedTime)
        );

        //check if full width is smaller than transition then make it dynamic

        if (array[i].startTransitionWidth > Number(TickerRef.current.max) / 2) {
          let MaxTotalMs = (Number(TickerRef.current.max) / 2) * OnePx;
          let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
          let downSizePercentage = maxPerWordMs / perWordMS;
          let upsizeOpacityIncrement =
            opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
          opacityIncrement = upsizeOpacityIncrement;
          perWordFPS = 60 * (1 - downSizePercentage) + 60;
          perWordTimeout = (1 / opacityIncrement) * perWordFPS;
          perWordMS = maxPerWordMs;
          wordsArray = [];
          cleanWordsArray = [];
          CalculatedTime = 0;

          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "<br>",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 3;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "&nbsp;",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 5;
            } else if (txt.charAt(j) == " ") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: " ",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            } else {
              word += txt.charAt(j);
            }
          }
          if (word != "") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
          }
        }

        array[i].wordByWordFadeInData = {
          CalculatedTime: CalculatedTime,
          opacityIncrement: opacityIncrement,
          perWordFPS: perWordFPS,
          perWordTimeout: perWordTimeout,
          perWordMS: perWordMS,
          cleanWordsArray: cleanWordsArray,
        };

        array[i].WordsArray = wordsArray;
        array[i].startTransitionWidth = calculateWidthByDuration(
          msToTime2(CalculatedTime + perWordMS)
        );
      } else if (types == "animated WordByWordAppear ") {
        var txt = array[i].text;
        let wordsArray = [];
        let cleanWordsArray = [];
        let word = "";
        let CalculatedTime = 0;
        let opacityIncrement = 0.03;
        let perWordFPS = 60;
        let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
        let perWordMS = 2000;

        for (let j = 0; j < txt.length; j++) {
          if (
            txt.charAt(j) == "<" &&
            txt.charAt(j + 1).toLowerCase() == "b" &&
            txt.charAt(j + 2).toLowerCase() == "r" &&
            txt.charAt(j + 3).toLowerCase() == ">"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "<br>",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout;
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            j = j + 3;
          } else if (
            txt.charAt(j) == "&" &&
            txt.charAt(j + 1).toLowerCase() == "n" &&
            txt.charAt(j + 2).toLowerCase() == "b" &&
            txt.charAt(j + 3).toLowerCase() == "s" &&
            txt.charAt(j + 4).toLowerCase() == "p" &&
            txt.charAt(j + 5).toLowerCase() == ";"
          ) {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "&nbsp;",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout;
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            j = j + 5;
          } else if (txt.charAt(j) == " ") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: " ",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout;
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
            // j = j + 6;
          } else {
            word += txt.charAt(j);
          }
        }
        if (word != "") {
          let obj = {
            id: `wbwf_${makeid(8)}`,
            word: word,
            next: "",
            startAt: CalculatedTime,
          };
          if (word != "") {
            CalculatedTime += perWordTimeout;
            cleanWordsArray.push(obj);
          }
          wordsArray.push(obj);
          word = "";
        }

        array[i].WordsArray = wordsArray;
        array[i].startTransitionWidth = calculateWidthByDuration(
          msToTime2(CalculatedTime)
        );

        if (array[i].startTransitionWidth > Number(TickerRef.current.max) / 2) {
          let MaxTotalMs = (Number(TickerRef.current.max) / 2) * OnePx;
          let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
          let downSizePercentage = maxPerWordMs / perWordMS;
          let upsizeOpacityIncrement =
            opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
          opacityIncrement = upsizeOpacityIncrement;
          perWordFPS = maxPerWordMs / 60; //(60 * (1 - downSizePercentage)) + 60;
          perWordTimeout = (1 / opacityIncrement) * perWordFPS;
          perWordMS = maxPerWordMs;
          wordsArray = [];
          cleanWordsArray = [];
          CalculatedTime = 0;

          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "<br>",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordMS;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 3;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "&nbsp;",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordMS;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 5;
            } else if (txt.charAt(j) == " ") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: " ",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordMS;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            } else {
              word += txt.charAt(j);
            }
          }
          if (word != "") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordMS;
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
          }
        }
        let scaleDecriment = 10 / (1 / opacityIncrement);
        array[i].wordByWordFadeInData = {
          CalculatedTime: CalculatedTime,
          opacityIncrement: opacityIncrement,
          perWordFPS: perWordFPS,
          perWordTimeout: perWordTimeout,
          perWordMS: perWordMS,
          cleanWordsArray: cleanWordsArray,
          scaleDecriment: scaleDecriment,
        };
        array[i].WordsArray = wordsArray;
        array[i].startTransitionWidth = calculateWidthByDuration(
          msToTime2(CalculatedTime + perWordMS)
        );
      }
    }

    setSlidesData(array);
    // setSupremeLayer({ ...SupremeLayer, Layer: array });
  }

  const [ActiveBackground, setActiveBackground] = useState("");

  const ApplyBackground = (count) => {
    let _check = false;
    let time = 0;
    let obj;

    if (!TickerStart) {
      setTickerStart(true);
    }
    for (let i = 0; i < SlideBackground.length; i++) {
      if (SlideBackground[i].time <= count && SlideBackground[i].time >= time) {
        time = SlideBackground[i].time;
        obj = clone(SlideBackground[i].background);
        _check = true;
      }
    }
    if (obj && Object.keys(obj).length != 0) {
      //checking if object is not empty
      if (Object.keys(obj).includes("animationPath")) {
        setActiveBackground("");
        setAnimatedBGData(obj.animationPath);
      } else {
        setAnimatedBGData("");
        setActiveBackground(obj);
      }
    } else {
      setAnimatedBGData("");
      setActiveBackground("");
    }
  };

  useEffect(() => {
    //if (DeafultLoader.stat) {
    var data = Lottie.getRegisteredAnimations();
    for (let i = 0; i < data.length; i++) {
      if (data[i].name == "PreviewLoader") {
        Lottie.destroy("PreviewLoader");
      }
    }
    Lottie.loadAnimation({
      container: AnimationRef.current,
      name: "PreviewLoader",
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: DLoader,
    });
  }, []);

  // audio start
  const AudioStart = (value, count, Play, loop) => {
    if (!value.Sound || value.Sound.paused === undefined) {
      value.Sound = new Audio(authenticationData.ApiBaseURL + "/" + value.path);
    }
    if (value.Sound) {
      if (value.Sound.paused) {
        if (!loop) {
          // Trimmed clip (startSound = where it starts in the file), loop and fades: same rules
          // as the export (Utils/soundTrim.js).
          if (count > value.startPositionOnTimeline) {
            const pxMs = OnePx;
            if (value.__stopFade) value.__stopFade();
            if (Play) value.__stopFade = playClip(value.Sound, {
              offsetSec: ((Number(value.startSound) || 0) * pxMs) / 1000,
              sec: ((count - value.startPositionOnTimeline) * pxMs) / 1000,
              clipSec: ((Number(value.widthOnTimeline) || 0) * pxMs) / 1000,
              // "Loop" repeats the clip after its bar ends (handled by the caller), not the file.
              loop: false,
              // "Lower while characters speak" (Utils/ducking.js)
              duck: value.duckUnderVoices ? () => window.__toonsDuckFactor || 1 : null,
              fadeIn: value.fadeIn,
              fadeOut: value.fadeOut,
              volume: (value.volume === null || value.volume === undefined || value.volume === "" ? 100 : Number(value.volume)) / 100,
              secNow: () => (((TickerRef.current ? Number(TickerRef.current.value) || 0 : 0) - value.startPositionOnTimeline) * pxMs) / 1000,
            });
            value.Sound.onended = function () {
              value.Sound.pause();
            };
          }
        } else {
          // "Loop": the clip plays again after its bar ends (each repeat starts at
          // startSoundValue on the timeline), with the same trim and fades.
          const pxMs = OnePx;
          const repeatStart =
            Number(value.startSoundValue) || Number(value.startPositionOnTimeline) || 0;
          if (value.__stopFade) value.__stopFade();
          if (Play) value.__stopFade = playClip(value.Sound, {
            offsetSec: ((Number(value.startSound) || 0) * pxMs) / 1000,
            sec: (Math.max(0, count - repeatStart) * pxMs) / 1000,
            clipSec: ((Number(value.widthOnTimeline) || 0) * pxMs) / 1000,
            loop: false,
            duck: value.duckUnderVoices ? () => window.__toonsDuckFactor || 1 : null,
            fadeIn: value.fadeIn,
            fadeOut: value.fadeOut,
            volume: (value.volume === null || value.volume === undefined || value.volume === "" ? 100 : Number(value.volume)) / 100,
            secNow: () => (((TickerRef.current ? Number(TickerRef.current.value) || 0 : 0) - repeatStart) * pxMs) / 1000,
          });
        }
      }
    }

    return;
  };

  useEffect(() => {
    const arr = Array.from(SlidesData);
    repairVoiceAudio(arr, authenticationData.ApiBaseURL);
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].Audio) {
        arr[i].Audio.pause();
      }
    }
    stopBgMusicWithPreview();
  }, [closeclick]);
  // audio stop
  const AudioStop = (value) => {
    if (!value.Sound || value.Sound.paused === undefined) {
      value.Sound = new Audio(authenticationData.ApiBaseURL + "/" + value.path);
    }

    if (value.Sound) {
      if (!value.Sound.paused) {
        if (value.Sound.pause) {
          setTimeout(() => {
            value.Sound.pause();
            value.Sound.currentTime = 0;
          }, 200);
        }
      }
    }

    if (value.Audio && value.TTSName) {
      if (!value.Audio.paused) {
        setTimeout(() => {
          value.Audio.pause();
          value.Audio.currentTime = 0;
        }, 200);
      }
    }

    if (value.startMusic) {
      value.startMusic = false;

      // change = true;
    }

    return;
  };

  const ForEmergencyLottiePlayer = async (value) => {
    try {
      if (!value.JSONValue) {
        if (value.character_FilePath != undefined) {
          const resp = await fetch(
            assetUrl(authenticationData.ApiBaseURL, value.character_FilePath)
          );
          value.JSONValue = await resp.json();
        }
      }

      const data = Lottie.getRegisteredAnimations();
      data.map((LottieData) => {
        if (LottieData.name == value.AnimationId) {
          Lottie.destroy(value.AnimationId);
        }
      });

      let _svg;
      if (value.type.toLowerCase() === "props")
        _svg = document.getElementById("Canvas-" + value.AnimationId);
      else _svg = document.getElementById("Loader" + value.AnimationId);

      const get = Lottie.loadAnimation({
        container: _svg,
        name: value.AnimationId,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: value.JSONValue,
        rendererSettings: {
          preserveAspectRatio: "xMidYMin slice",
          viewBoxOnly: true,
          progressiveLoad: true,
        },
      });

      return get;
    } catch (ex) {}
  };

  const Check = async (count) => {
    ApplyBackground(count);

    if (count == 0) return;

    const array = Array.from(SlidesData);

    repairVoiceAudio(array, authenticationData.ApiBaseURL);
    let change = false;

    for (let i = 0; i < array.length; i++) {
      array[i].DrapEndAnimatedText = false;
      if (TickerPlay === Tl_TotalTime_Width) {
        setPlay(false);
        if (array[i].type === "Character") {
          if (array[i].Audio) {
            if (array[i].Audio.paused !== undefined) {
              array[i].Audio.pause();
            }
          }
        }
      }

      let _visible = true;
      if (array[i].TotalSlideTime) {
        if (array[i].TotalSlideTime >= count) {
          _visible = true;
        } else {
          AudioStop(array[i]);
          _visible = false;
        }
      } else {
        _visible = true;
      }

      if (Play == false && array[i].Audio) {
        //console.log("Audio is paused");
        if (!array[i].Audio.paused) {
          array[i].Audio.pause();
          // change = true;
        }
      }

      var _StartPositionOnTimeline;

      if (
        array[i].type == "Character" ||
        array[i].type == "AnimatedText" ||
        array[i].type === "audio"
      ) {
        if (array[i].type == "Character") {
          if (array[i].TTSName != "" && array[i].TTSName != undefined) {
            if (
              array[i].LastStartPositionOnTimeline == 0 ||
              array[i].LastStartPositionOnTimeline === undefined ||
              isNaN(array[i].LastStartPositionOnTimeline)
            ) {
              _StartPositionOnTimeline = array[i].startPositionOnTimeline;
            } else {
              _StartPositionOnTimeline = array[i].LastStartPositionOnTimeline;
            }
          }
        } else {
          if (
            array[i].LastStartPositionOnTimeline == 0 ||
            array[i].LastStartPositionOnTimeline === undefined ||
            isNaN(array[i].LastStartPositionOnTimeline)
          ) {
            _StartPositionOnTimeline = array[i].startPositionOnTimeline;
          } else {
            _StartPositionOnTimeline = array[i].LastStartPositionOnTimeline;
          }
        }
      } else {
        _StartPositionOnTimeline = array[i].startPositionOnTimeline;
      }

      if (array[i].type === "audio") {
        if (count == Tl_TotalTime_Width) {
          AudioStop(array[i]);
        }

        if (array[i].widthOnTimeline >= Tl_TotalTime_Width) {
          if (
            _StartPositionOnTimeline <= count &&
            _StartPositionOnTimeline + array[i].widthOnTimeline >= count &&
            count != Tl_TotalTime_Width
          ) {
            await AudioStart(array[i], count, Play, false);
          } else if (
            _StartPositionOnTimeline + array[i].widthOnTimeline < count &&
            count != Tl_TotalTime_Width
          ) {
            if (array[i].loop) {
              await AudioStart(array[i], count, Play, true);
            } else {
              await AudioStop(array[i]);
            }
          } else {
            await AudioStop(array[i]);
          }
        } else {
          if (
            _StartPositionOnTimeline <= count &&
            _StartPositionOnTimeline + array[i].widthOnTimeline >= count &&
            count !== Tl_TotalTime_Width
          ) {
            await AudioStart(array[i], count, Play, false);
          } else if (
            _StartPositionOnTimeline + array[i].widthOnTimeline <
            count
          ) {
            if (array[i].loop) {
              if (!array[i].changeStartValue) {
                await AudioStop(array[i]);
                array[i].startSoundValue = count;
                array[i].changeStartValue = true;
              }

              if (
                array[i].startSoundValue <= count &&
                array[i].startSoundValue + array[i].widthOnTimeline >= count &&
                count !== Tl_TotalTime_Width
              ) {
                await AudioStart(array[i], count, Play, true);
              } else {
                array[i].changeStartValue = false;
              }
            } else {
              await AudioStop(array[i]);
            }
          } else if (_StartPositionOnTimeline < count) {
            await AudioStop(array[i]);
          }
        }
      }

      // if (array[i].type === "audio") {
      //   if (array[i].widthOnTimeline >= Tl_TotalTime_Width) {
      //     if (count == Tl_TotalTime_Width) {
      //       if (array[i].startMusic) {
      //         array[i].startMusic = false;
      //         change = true;
      //       }
      //     } else if (
      //       _StartPositionOnTimeline <= count &&
      //       _StartPositionOnTimeline + array[i].widthOnTimeline >= count
      //     ) {
      //       if (!array[i].startMusic) {
      //         array[i].startMusic = true;
      //         change = true;
      //       }
      //     } else {
      //       if (array[i].startMusic) {
      //         array[i].startMusic = false;
      //         change = true;
      //       }
      //     }
      //   }
      //   else {
      //     let widthOnTimeline = 0;
      //     if (
      //       _StartPositionOnTimeline + array[i].widthOnTimeline >
      //       Tl_TotalTime_Width
      //     ) {
      //       widthOnTimeline = Tl_TotalTime_Width;
      //     } else {
      //       widthOnTimeline =
      //         _StartPositionOnTimeline + array[i].widthOnTimeline;
      //     }

      //     if (_StartPositionOnTimeline <= count && widthOnTimeline > count) {
      //       if (!array[i].startMusic) {
      //         array[i].startMusic = true;
      //         change = true;
      //       }
      //     }
      //     else if (_StartPositionOnTimeline + array[i].widthOnTimeline < count)
      //     {
      //       if(array[i].loop)
      //       {
      //         if(!array[i].preview_changeStartValue)
      //         {
      //           change = true;
      //           array[i].startSoundValue = count;
      //           array[i].preview_changeStartValue = true;
      //           array[i].startMusic = false;
      //           array[i].previewSoundCurrentTime = 0;
      //           array[i].player = false;

      //         }

      //         if(array[i].startSoundValue <= count && (array[i].startSoundValue + array[i].widthOnTimeline) >= count)
      //         {
      //           if (!array[i].startMusic) {
      //             array[i].startMusic = true;
      //             array[i].player = true;
      //             change = true;
      //           }
      //         }
      //         else if ((array[i].startSoundValue + array[i].widthOnTimeline) >= count)
      //         {
      //           if(array[i].preview_changeStartValue)
      //           {
      //             array[i].preview_changeStartValue = false;
      //           }

      //         }
      //       }
      //     }
      //     else {
      //       if (array[i].startMusic) {
      //         array[i].startMusic = false;
      //         change = true;
      //       }
      //     }
      //   }
      // }

      if (array[i].type == "AnimatedText") {
        if (count >= _StartPositionOnTimeline) {
          array[i].DrapEndAnimatedText = false;
          if (count < _StartPositionOnTimeline + 10) {
            if (!array[i].LoadLottie) {
              array[i].LoadLottie = true;
              // array[i].endTimeOfAnimatedText = true;
              // array[i].speedOn = false;
              // array[i].fastspeedOn = false;
              change = true;
            }
          }

          if (array[i].widthOnTimeline == count) {
            array[i].DrapEndAnimatedText = true;
            change = true;
          } else {
            if (array[i].DrapEndAnimatedText) {
              array[i].DrapEndAnimatedText = false;
            }
          }

          if (array[i].widthOnTimeline >= 465) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 225 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].playSegmentFrom = 480;
                array[i].playSegmentTo = 600;
              }
            }
          } else if (
            array[i].widthOnTimeline > 349 &&
            array[i].widthOnTimeline < 465
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 200 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 495;
                array[i].playSegmentTo = 600;
              }
            }
          } else if (
            array[i].widthOnTimeline > 225 &&
            array[i].widthOnTimeline < 349
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 175 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 505;
                array[i].playSegmentTo = 600;
              }
            }
          } else if (
            array[i].widthOnTimeline > 117 &&
            array[i].widthOnTimeline < 233
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 100 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = true;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 460;
                array[i].playSegmentTo = 600;
              }
            }
          } else {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 50 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = true;
                array[i].playSegmentFrom = 520;
                array[i].playSegmentTo = 600;
              }
            }
          }
        } else if (_StartPositionOnTimeline - 5 < count) {
          if (!array[i].LoadLottie) {
            array[i].LoadLottie = true;
            array[i].DrapEndAnimatedText = false;
            // array[i].endTimeOfAnimatedText = true;
            // array[i].speedOn = false;
            // array[i].fastspeedOn = false;
            change = true;
          }
        }
      }

      let aToZStart = array[i].startPositionOnTimeline;

      if (array[i].InEffect !== "none") {
        aToZStart =
          array[i].startPositionOnTimeline + array[i].startTransitionWidth;

        if (array[i].InEffect === "animated TypeWriterr ") {
          var totalwidth = array[i].originalX + array[i].width;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            if (count - array[i].startPositionOnTimeline > 0) {
              var txt = array[i].originalText;
              var StrCounter = txt.length + 1;

              let tickerPositionInEffect =
                count - array[i].startPositionOnTimeline;
              let divider = array[i].startTransitionWidth / StrCounter;
              let appendIndex = parseInt(tickerPositionInEffect / divider);
              let str = "";
              for (let j = 0; j < appendIndex - 1; j++) {
                if (
                  txt.charAt(j) == "<" &&
                  txt.charAt(j + 1).toLowerCase() == "b" &&
                  txt.charAt(j + 2).toLowerCase() == "r" &&
                  txt.charAt(j + 3).toLowerCase() == ">"
                ) {
                  str += "<br>";
                  j = j + 4;
                } else if (
                  txt.charAt(j) == "&" &&
                  txt.charAt(j + 1).toLowerCase() == "n" &&
                  txt.charAt(j + 2).toLowerCase() == "b" &&
                  txt.charAt(j + 3).toLowerCase() == "s" &&
                  txt.charAt(j + 4).toLowerCase() == "p" &&
                  txt.charAt(j + 5).toLowerCase() == ";"
                ) {
                  str += "&nbsp;";
                  j = j + 6;
                } else {
                  str += txt.charAt(j);
                }
              }
              array[i].text = str;
            }
            change = true;
          }
        }
        if (
          (array[i].InEffect === "animated TextBounce " ||
            array[i].InEffect === "animated TypeWriter ") &&
          !Play
        ) {
          var totalwidth = array[i].originalX + array[i].width;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            if (count - array[i].startPositionOnTimeline > 0) {
              var txt = array[i].originalText;
              var StrCounter = txt.length + 1;

              let tickerPositionInEffect =
                count - array[i].startPositionOnTimeline;
              let divider = array[i].startTransitionWidth / StrCounter;
              let appendIndex = parseInt(tickerPositionInEffect / divider);
              let $el = document.getElementById(array[i].TextId);
              if ($el) {
                $el.innerHTML = "";
                for (let j = 0; j < array[i].CharactersArray.length; j++) {
                  let obj = array[i].CharactersArray[j];
                  if (obj) {
                    let span = document.createElement("span");
                    span.id = obj.id;
                    if (j < appendIndex - 1) {
                      span.style.opacity = 1;
                      span.setAttribute("data-doneBounce", 1);
                    } else {
                      span.style.opacity = 0;
                    }
                    if (obj.character == "") {
                      span.style.opacity = 1;
                      span.setAttribute("data-empty", "1");
                    } else {
                      span.style.position = "relative";
                    }
                    span.innerHTML = obj.character + obj.next;
                    $el.appendChild(span);
                  }
                }
              }
            }
          }
        }
        if (array[i].InEffect === "animated WordByWordFade ") {
          var totalwidth = array[i].originalX + array[i].width;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            if (count - array[i].startPositionOnTimeline > 0) {
              var txt = array[i].originalText;
              var StrCounter = array[i].WordsArray.length + 1;

              let tickerPositionInEffect =
                count - array[i].startPositionOnTimeline;
              let divider = array[i].startTransitionWidth / StrCounter;
              let appendIndex = parseInt(tickerPositionInEffect / divider);
              let _opacity = (tickerPositionInEffect / divider) % 1;
              let $el = document.getElementById(array[i].TextId);
              $el.innerHTML = "";
              for (const j of array[i].WordsArray) {
                let span = document.createElement("span");
                span.style.opacity = 0;
                span.id = j.id;
                if (j.word == "") {
                  span.style.opacity = 1;
                  span.setAttribute("data-empty", "1");
                }
                span.innerHTML = j.word + j.next;
                $el.appendChild(span);
              }

              for (let j = 0; j < appendIndex - 1; j++) {
                let span = document.getElementById(array[i].WordsArray[j].id);
                if (j == appendIndex - 2) {
                  span.style.opacity = _opacity;
                } else {
                  span.style.opacity = 1;
                }
              }
            }
          }
        }
        if (array[i].InEffect === "animated WordByWordAppear ") {
          var totalwidth = array[i].originalX + array[i].width;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            if (count - array[i].startPositionOnTimeline > 0) {
              var txt = array[i].originalText;

              var StrCounter = array[i].WordsArray.length + 1;

              let tickerPositionInEffect =
                count - array[i].startPositionOnTimeline;
              let divider = array[i].startTransitionWidth / StrCounter;
              let appendIndex = parseInt(tickerPositionInEffect / divider);

              let _opacity = (tickerPositionInEffect / divider) % 1;
              let $el = document.getElementById(array[i].TextId);
              $el.innerHTML = "";
              for (const j of array[i].WordsArray) {
                let span = document.createElement("span");
                span.style.opacity = 0;
                span.id = j.id;
                if (j.word == "") {
                  span.style.opacity = 1;
                  span.setAttribute("data-empty", "1");
                } else {
                  span.style.position = "absolute";
                  span.style.color = "transparent";
                  span.style.textShadow = `0 0 10px ${array[i].textColor}`;
                  span.style.fontSize = array[i].fontSize + 10 + "px";
                }
                span.innerHTML = " " + j.word + j.next;
                $el.appendChild(span);
              }

              for (let j = 0; j < appendIndex - 1; j++) {
                let span = document.getElementById(array[i].WordsArray[j].id);
                span.style.opacity = 1;
                if (j == appendIndex - 2) {
                  //span.style.opacity = _opacity;

                  let fontSize =
                    Number(span.style.fontSize.split("px")[0]) - _opacity * 10;
                  let textShadow = 10 - _opacity * 10;
                  span.style.fontSize = fontSize + "px";
                  span.style.textShadow = `0 0 ${textShadow}px ${array[i].textColor}`;
                } else {
                  span.style.position = "";
                  span.style.fontSize = "";
                  span.style.textShadow = "";
                  span.style.color = "";
                  span.innerHTML = span.innerHTML.split(" ")[1] + " ";
                }
              }
            }
          }
        }
        if (array[i].InEffect === "animated slideInRight ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth =
            document.getElementsByClassName("video-preview")[0].clientWidth +
            10;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = totalwidth - startpoint * diff;
            change = true;
          }
        }
        if (array[i].InEffect === "animated swipeInRight ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX + 10;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = totalwidth - startpoint * diff;
            change = true;

            //Fading in with Swipe
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = count - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
        }
        if (array[i].InEffect === "animated slideInLeft ") {
          let _mcount;
          //debugger;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          //totalwidth is position from where it should start animating
          // var totalwidth =
          //   array[i].originalX -
          //   document.getElementsByClassName("video-preview")[0].clientWidth;
          //var totalwidth = array[i].originalX - array[i].width;
          var totalwidth = 0 - array[i].width;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = Math.abs(startpoint * diff) + totalwidth;
            change = true;
          }
        }
        if (array[i].InEffect === "animated swipeInLeft ") {
          let _mcount;
          //debugger;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          //totalwidth is position from where it should start animating
          // var totalwidth =
          //   array[i].originalX -
          //   document.getElementsByClassName("video-preview")[0].clientWidth;
          //var totalwidth = array[i].originalX - array[i].width;
          var totalwidth = array[i].originalX - 10;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = Math.abs(startpoint * diff) + totalwidth;
            change = true;

            //Fading in with Swipe
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = count - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
        }
        if (array[i].InEffect === "animated slideInDown ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }

          var totalHeight =
            document.getElementsByClassName("video-preview")[0].clientHeight +
            10;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].y = totalHeight - startpoint * diff;
          }
        }
        if (array[i].InEffect === "animated swipeInDown ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }

          var totalHeight = array[i].originalY - 20;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].y = totalHeight - startpoint * diff;

            //Fading in with Swipe
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = count - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
        }
        if (array[i].InEffect === "animated slideInUp ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          var totalHeight = 0 - array[i].height;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;

            array[i].y = totalHeight - startpoint * diff;
            change = true;
          }
        }
        if (array[i].InEffect === "animated swipeInUp ") {
          let _mcount;
          if (
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                1 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                2 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                3 ||
            count ==
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth +
                4
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          var totalHeight = array[i].originalY + 20;
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;

            array[i].y = totalHeight - startpoint * diff;
            change = true;

            //Fading in with Swipe
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = count - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
        }
        if (array[i].InEffect === "animated fadeIn ") {
          var totalHeight = array[i].originalX + array[i].height;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = count - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint / array[i].startTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
        }
        if (array[i].InEffect === "animated zoomIn ") {
          var totalHeight = array[i].originalX + array[i].originalHeight;
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = count - array[i].startPositionOnTimeline;
            let percentage = startpoint / array[i].startTransitionWidth;
            if (percentage >= 0) {
              array[i].width = percentage * array[i].originalWidth;
              array[i].height = percentage * array[i].originalHeight;
              array[i].x =
                array[i].originalX +
                (array[i].originalWidth - array[i].width) / 2;
              array[i].y =
                array[i].originalY +
                (array[i].originalHeight - array[i].height) / 2;
              if (array[i].type == "text") {
                array[i].fontSize = parseInt(
                  array[i].originalFontSize * percentage
                );
              }
            }
            change = true;
          }
        }
      }

      if (array[i].OutEffect !== "none") {
        if (array[i].OutEffect === "animated slideOutLeft ") {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = 0 - array[i].width;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            change = true;
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutLeft")) {
          //       _preview.classList.remove("slideOutLeft");
          //     }
          //   }
          //   array[i].x = array[i].originalX;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutLeft ") {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX - 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            change = true;

            //Fade out with Swiping Left
            let TickerIncr = count - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutLeft")) {
          //       _preview.classList.remove("slideOutLeft");
          //     }
          //   }
          //   array[i].x = array[i].originalX;
          // }
        }
        if (array[i].OutEffect === "animated slideOutRight ") {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth =
            document.getElementsByClassName("video-preview")[0].clientWidth +
            10;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            change = true;
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutRight")) {
          //       _preview.classList.remove("slideOutRight");
          //     }
          //   }
          //   array[i].x = array[i].originalX;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutRight ") {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX + 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            change = true;

            //Fade out with Swiping Right
            let TickerIncr = count - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;
            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutRight")) {
          //       _preview.classList.remove("slideOutRight");
          //     }
          //   }
          //   array[i].x = array[i].originalX;
          // }
        }
        if (array[i].OutEffect === "animated slideOutUp ") {
          var totalHeight = 0 - array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;
            change = true;
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutUp")) {
          //       _preview.classList.remove("slideOutUp");
          //     }
          //   }
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutUp ") {
          var totalHeight = array[i].originalY - 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;
            change = true;

            //Fade out with Swiping up
            let TickerIncr = count - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutUp")) {
          //       _preview.classList.remove("slideOutUp");
          //     }
          //   }
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated slideOutDown ") {
          var totalHeight =
            document.getElementsByClassName("video-preview")[0].clientHeight +
            10;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;
            change = true;
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutDown")) {
          //       _preview.classList.remove("slideOutDown");
          //     }
          //   }
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutDown ") {
          var totalHeight = array[i].originalY + 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = count - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;
            change = true;
            //Fade out with Swiping up
            let TickerIncr = count - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("slideOutDown")) {
          //       _preview.classList.remove("slideOutDown");
          //     }
          //   }
          //   array[i].y = array[i].originalY;
          // }
        }

        if (array[i].OutEffect === "animated fadeOut ") {
          var totalwidth = array[i].originalX + array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let TickerIncr = count - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;

            if (array[i].originalOpacity >= opacityPercentage) {
              array[i].opacity = opacityPercentage;
              change = true;
            }
          }
          // else {
          //   const _preview = document.getElementById(
          //     "Preview-" + array[i].AnimationId
          //   );
          //   if (_preview) {
          //     if (_preview.classList.contains("fadeOut")) {
          //       _preview.classList.remove("fadeOut");
          //     }
          //   }
          //   array[i].opacity = array[i].originalOpacity;
          // }
        }
        if (array[i].OutEffect === "animated zoomOut ") {
          var totalwidth = array[i].originalX + array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);
          if (
            grandWidth <= count &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
          ) {
            let TickerIncr = count - grandWidth;

            let percentage = 1 - TickerIncr / array[i].endTransitionWidth;
            if (percentage >= 0) {
              array[i].width = percentage * array[i].originalWidth;
              array[i].height = percentage * array[i].originalHeight;
              array[i].x =
                array[i].originalX +
                (array[i].originalWidth - array[i].width) / 2;
              array[i].y =
                array[i].originalY +
                (array[i].originalHeight - array[i].height) / 2;
              if (array[i].type == "text") {
                array[i].fontSize = parseInt(
                  array[i].originalFontSize * percentage
                );
              }
            }
            change = true;
          } else {
            const _preview = document.getElementById(
              "Preview-" + array[i].AnimationId
            );
            if (_preview) {
              if (_preview.classList.contains("zoomOut")) {
                _preview.classList.remove("zoomOut");
              }
            }
            array[i].fontSize = array[i].originalFontSize;
            array[i].x = array[i].originalX;
            array[i].y = array[i].originalY;
            array[i].width = array[i].originalWidth;
            array[i].height = array[i].originalHeight;
          }
        }
      }

      // show/hide character after restart...

      if (
        array[i].startPositionOnTimeline <= count &&
        array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count &&
        _visible
      ) {
        if (!array[i].player) {
          array[i].isStartTalking = true;
          array[i].player = true;
          array[i].Animate = true;
          //change = true;
        }
      } else {
        if (array[i].player) {
          array[i].isStartTalking = true;
          array[i].player = false;
          array[i].Animate = false;
          //change = true;
        }
      }

      // if (_StartPositionOnTimeline === array[i].startPositionOnTimeline) {
      // 	array[i].isStartTalking = true;
      //   }

      // Voices: a trimmed voice stops at its end, and no voice plays outside its block on the
      // timeline (TTSTrimStart / TTSTrimEnd, see the character's Voice settings).
      if (
        array[i].TTSName &&
        array[i].Audio &&
        array[i].Audio.paused === false &&
        Number(array[i].midTransitionWidths) > 0 &&
        (count < _StartPositionOnTimeline ||
          count > _StartPositionOnTimeline + Number(array[i].midTransitionWidths))
      ) {
        array[i].Audio.pause();
      }

      if (
        _StartPositionOnTimeline == count &&
        array[i].TTSName != "" &&
        array[i].TTSName
      ) {
        array[i].isStopTalking = true;
        stopTalking(array[i].JSONValue);
        change = true;
      } else if (
        _StartPositionOnTimeline <= count &&
        _StartPositionOnTimeline + array[i].midTransitionWidths >= count &&
        array[i].TTSName != "" &&
        array[i].TTSName &&
        array[i].player === true
      ) {
        if (array[i].isPlaying == false) {
          var _diff;
          if (array[i].isTickerMove) {
            _diff =
              parseFloat(TickerRef.current.value) - _StartPositionOnTimeline;
            _diff = _diff * OnePx;
            if (_diff <= 0) {
              _diff = "00.00";
            } else {
              _diff = parseFloat(_diff + "0");
            }
          } else {
            if (array[i].StartAudioTime)
              _diff =
                parseFloat(array[i].StartAudioTime) -
                parseFloat(_StartPositionOnTimeline);
            else _diff = 0;

            _diff = _diff * OnePx;
          }

          if (_diff <= 0) {
            _diff = 0;
          }

          if (array[i].TTSName && !array[i].Audio.src) {
            array[i].Audio = new Audio(
              authenticationData.ApiBaseURL + "/" + array[i].TTSPath
            );
          }

          let timeonticker = msToTime3(_diff);
          let three_dec = timeonticker.slice(0, 9);
          let min_sec = three_dec.slice(three_dec);
          let sec = min_sec.split(":")[1];

          if (array[i].isTickerMove && Play) {
            var _sec;
            // if(_StartPositionOnTimeline === array[i].startPositionOnTimeline)
            // {
            if (parseInt(sec.split(".")[0]) > 0) {
              _sec = parseInt(sec.split(".")[0]);
            } else {
              _sec = "00";
            }
            // }
            // else
            // {
            //     if(parseInt(sec.split(".")[0]) > 0)
            //     {
            //         _sec = parseInt(sec.split(".")[0]);
            //     }
            //     else
            //     {
            //         _sec = "00";
            //     }
            // }

            if (_sec < 10 && _sec != "00") {
              _sec = "0" + _sec;
            }

            sec = _sec + "." + sec.split(".")[1];
            array[i].isTickerMove = undefined;
          }

          if (isFinite(sec)) {
            if (array[i].PauseTime) {
              // array[i].Audio.currentTime = array[i].PauseTime;

              if (array[i].Audio) {
                array[i].Audio.play();
              }

              array[i].PauseTime = undefined;
            } else {
              // A trimmed voice starts TTSTrimStart seconds into its file.
              array[i].Audio.currentTime =
                parseFloat(sec) + (Number(array[i].TTSTrimStart) || 0);
            }
          }

          if (Play && array[i].Audio.paused) {
            array[i].Audio.play();
          } else if (!Play && !array[i].Audio.paused) {
            if (array[i].Audio) {
              if (array[i].Audio.paused !== undefined) {
                array[i].Audio.pause();
              }
            }
          }
          var _find_Talk_Month = array[i].JSONValue.assets[1].layers.find(
            (x) => x.nm === "Mouth_Talk"
          );

          if (!_find_Talk_Month) {
            if (array[i].JSONValue.assets.find((x) => x.nm == "Mouth_Comp")) {
              _find_Talk_Month = array[i].JSONValue.assets
                .find((x) => x.nm == "Mouth_Comp")
                .layers.find((y) => y.nm == "Mouth_Talk");
            } else if (
              array[i].JSONValue.assets.find((x) => x.id == "comp_11")
            ) {
              _find_Talk_Month = array[i].JSONValue.assets
                .find((x) => x.id == "comp_11")
                .layers.find((y) => y.nm == "Mouth_Talk");
            }
          }

          if (Play) {
            if (_find_Talk_Month) {
              if (
                _find_Talk_Month.hd === false &&
                array[i].isStartTalking === false
              ) {
                array[i].isStartTalking = true;
                change = true;
              }
            }
          }
          if (_find_Talk_Month) {
            if (_find_Talk_Month.hd) {
              startTalking(array[i].JSONValue);
              array[i].isStartTalking = true;
              change = true;
            }
          }

          array[i].isPlaying = true;
        }
      }
      // else if (
      //     array[i].startPositionOnTimeline + array[i].widthOnTimeline <=
      //     count
      //   ) {

      //     if (array[i].player) {
      //         if(array[i].type === "Character")
      //         {
      //             if(array[i].Audio)
      //             {
      //                 if(array[i].Audio.paused !== undefined)
      //                 {
      //                     array[i].Audio.pause();
      //                 }
      //             }

      //         }
      //         console.log("f")
      //     array[i].isHide = true;
      //     array[i].player = false;
      //     array[i].InClass = "";
      //     array[i].OutClass = "";

      //       if (array[i].InEffect == "animated WordByWordFade ") {
      //         array[i].text = array[i].originalText;
      //       }
      //       change = true;
      //     }
      //     if (array[i].startAtoZ) {
      //       array[i].startAtoZ = false;
      //       change = true;
      //     }
      //     if (array[i].Animate) {
      //       array[i].Animate = false;
      //       change = true;
      //     }
      //   }
      else if (array[i].TTSName != "" && array[i].TTSName) {
        if (!Play && array[i].Audio) {
          array[i].Audio.currentTime = 0;
          // change = true;
        }

        var _find_Talk_Month = array[i].JSONValue.assets[1].layers.find(
          (x) => x.nm === "Mouth_Talk"
        );

        if (!_find_Talk_Month) {
          if (array[i].JSONValue.assets.find((x) => x.nm == "Mouth_Comp")) {
            _find_Talk_Month = array[i].JSONValue.assets
              .find((x) => x.nm == "Mouth_Comp")
              .layers.find((y) => y.nm == "Mouth_Talk");
          } else {
            _find_Talk_Month = array[i].JSONValue.assets[0].layers
              .find((x) => x.nm == "Mouth_Comp")
              .layers.find((y) => y.nm == "Mouth_Talk");
          }
        }

        if (_find_Talk_Month && !_find_Talk_Month.hd) {
          stopTalking(array[i].JSONValue);
          array[i].isStopTalking = true;
          change = true;
        }
      }

      if (
        _StartPositionOnTimeline <= count &&
        _visible &&
        array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
      ) {
        if (!array[i].player) {
          // if (checkPlaying) {
          //     array[i].player = true
          // }
          //array[i].player = true;
          // change = true
        }

        if (
          array[i].type === "Character" ||
          array[i].type === "SlideTransition"
        ) {
          if (array[i].InEffect === "none") {
            if (!array[i].Animate) {
              array[i].Animate = true;
              // change = true
            }
          }
          if (
            _StartPositionOnTimeline + array[i].startTransitionWidth <
            count
          ) {
            if (array[i].InEffect !== "none") {
              if (array[i].AzData === null) {
                if (!array[i].Animate) {
                  array[i].Animate = true;
                  // change = true
                }
              } else {
                if (!array[i].startAtoZ) {
                  array[i].startAtoZ = true;
                  // change = true
                }
              }
            }
          }
        }

        // if (
        //   array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
        //   count
        // ) {
        //   if (array[i].InEffect !== "none") {
        //     if (array[i].InClass === "") {
        //       array[i].OutClass = "";
        //       array[i].InClass = array[i].InEffect;

        //       if (
        //         array[i].InEffect == "animated WordByWordFade " ||
        //         array[i].InEffect == "animated WordByWordAppear "
        //       ) {
        //         array[i].text = "";
        //       }
        //       // change = true
        //     }
        //   }
        // }

        if (
          array[i].startPositionOnTimeline +
            (array[i].startTransitionWidth + array[i].startTransitionWidth) <=
          count
        ) {
          if (array[i].InEffect !== "none") {
            if (array[i].InClass !== "") {
              array[i].OutClass = "";
              array[i].InClass = "";
              // change = true
            }
          }
        }

        if (
          array[i].startPositionOnTimeline +
            array[i].widthOnTimeline -
            array[i].endTransitionWidth <=
          count
        ) {
          if (array[i].OutEffect !== "none") {
            if (array[i].Animate) {
              array[i].Animate = false;
              // change = true
            }
            if (array[i].startAtoZ) {
              array[i].startAtoZ = false;
              // change = true
            }
            if (array[i].OutClass === "") {
              array[i].InClass = "";
              array[i].OutClass = array[i].OutEffect;
              // change = true
            }
          }
        }
      } else if (
        array[i].startPositionOnTimeline + array[i].widthOnTimeline <= count ||
        array[i].TotalSlideTime <= count
      ) {
        //this code is working to hide objects
        if (array[i].player) {
          if (array[i].type === "Character") {
            if (array[i].Audio) {
              if (array[i].Audio.paused !== undefined) {
                array[i].Audio.pause();
              }
            }
          }
          //console.log("e");
          array[i].isHide = true;
          array[i].player = false;
          array[i].InClass = "";
          array[i].OutClass = "";
          // change = true
        }
        if (array[i].startAtoZ) {
          array[i].startAtoZ = false;
          // change = true
        }
        if (array[i].Animate) {
          array[i].Animate = false;
          // change = true
        }
      }
      array[i].is_mtrans_call = false;

      // if(array[i].startPositionOnTimeline <= count
      //     && array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count)
      // {
      //   if (!array[i].player)
      //   {
      //     console.log("b")
      //     array[i].isHide = false;
      //     array[i].player = true;
      //     array[i].Animate = true;
      //     change = true;
      //   }
      // }
      // else
      // {

      //   if (array[i].player)
      //   {
      //     if(array[i].type === "Character")
      //     {
      //         if(array[i].Audio)
      //         {
      //             if(array[i].Audio.paused !== undefined)
      //             {
      //                 array[i].Audio.pause();
      //             }
      //         }
      //     }
      //     console.log("c")
      //     array[i].isHide = true;
      //     array[i].player = false;
      //     array[i].Animate = false;
      //     change = true;
      //   }
      // }
    }

    if (change) {
      //  setSupremeLayer({
      //     TotalTime: SlideTime,
      //     Layer: array,
      //     setInEditor: false
      //  })
      //  setSupremeLayer({...SupremeLayer,Layer: array})
      //  SupremeLayer.layer=array;
      //  setSupremeLayer(SupremeLayer);

      setSlidesData(array);
    }
  };

  const startTalking = (jsondata) => {
    const _jsonData = jsondata.assets[1].layers;
    const _jsonData2 = jsondata.assets[0].layers;
    const _jsonData3 = jsondata.layers[0].layers;

    if (jsondata.assets.find((x) => x.nm == "Mouth_Comp")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.nm == "Mouth_Comp"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = false;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = true;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = false;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = true;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_0")) {
      if (
        jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp")
      ) {
        const _jsonDataEditor = jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp").layers;
        for (let i = 0; i < _jsonDataEditor.length; i++) {
          if (_jsonDataEditor[i].nm === "Mouth_Talk") {
            _jsonDataEditor[i].hd = false;
          } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
            _jsonDataEditor[i].hd = true;
          }
        }
      }
    }

    if (jsondata.layers) {
      if (jsondata.layers[0].layers) {
        if (jsondata.layers[0].layers.find((x) => x.nm == "Mouth_Comp")) {
          const _jsonDataEditor = jsondata.layers[0].layers.find(
            (x) => x.nm == "Mouth_Comp"
          ).layers;
          console.log('_jsonDataEditor', _jsonDataEditor)
          for (let i = 0; i < _jsonDataEditor.length; i++) {
            if (_jsonDataEditor[i].nm === "Mouth_Talk") {
              _jsonDataEditor[i].hd = false;
            } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
              _jsonDataEditor[i].hd = true;
            }
          }
        }
      }
    }

    _jsonData.map((value) => {
      if (value.nm === "Mouth_Talk") {
        value.hd = false;
      } else if (value.nm === "Mouth_Static") {
        value.hd = true;
      }
    });

    _jsonData2.map((value2, index2) => {
      if (_jsonData2.length !== index2) {
        if (value2.nm.toLowerCase() === "mouth") {
          value2.layers.map((value3, index3) => {
            if (value2.layers.length !== index3) {
              if (value3.nm === "Mouth_Talk") {
                value3.hd = false;
              } else if (value3.nm === "Mouth_Static") {
                value3.hd = true;
              }
            }
          });
        }
      }
    });

    _jsonData3.map((value, index) => {
      if (_jsonData3.length !== index) {
        if (value.nm === "Mouth" || value.nm === "mouth") {
          value.layers.map((value2, index2) => {
            if (value.layers.length !== index2) {
              if (value2.nm === "Mouth_Talk") {
                value2.hd = false;
              } else if (value2.nm === "Mouth_Static") {
                value2.hd = true;
              }
            }
          });
        }
      }
    });
  };

  const stopTalking = async (jsondata, value) => {
    const _jsonData = jsondata.assets[1].layers;
    const _jsonData2 = jsondata.assets[0].layers;
    const _jsonData3 = jsondata.layers[0].layers;

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = true;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = false;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = true;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = false;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_0")) {
      if (
        jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp")
      ) {
        const _jsonDataEditor = jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp").layers;
        for (let i = 0; i < _jsonDataEditor.length; i++) {
          if (_jsonDataEditor[i].nm === "Mouth_Talk") {
            _jsonDataEditor[i].hd = true;
          } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
            _jsonDataEditor[i].hd = false;
          }
        }
      }
    }

    if (jsondata.layers) {
      if (jsondata.layers[0].layers) {
        if (jsondata.layers[0].layers.find((x) => x.nm == "Mouth_Comp")) {
          const _jsonDataEditor = jsondata.layers[0].layers.find(
            (x) => x.nm == "Mouth_Comp"
          ).layers;
          for (let i = 0; i < _jsonDataEditor.length; i++) {
            if (_jsonDataEditor[i].nm === "Mouth_Talk") {
              _jsonDataEditor[i].hd = true;
            } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
              _jsonDataEditor[i].hd = false;
            }
          }
        }
      }
    }

    for (let i = 0; i <= _jsonData.length - 1; i++) {
      if (_jsonData[i].nm === "Mouth_Talk") {
        _jsonData[i].hd = true;
      } else if (_jsonData[i].nm === "Mouth_Static") {
        _jsonData[i].hd = false;
      }
    }

    for (let i = 0; i <= _jsonData2.length - 1; i++) {
      if (_jsonData2[i].nm == "Mouth" || _jsonData2[i].nm == "mouth") {
        for (let j = 0; j <= _jsonData2[i].layers.length - 1; j++) {
          if (_jsonData2[i].layers[j].nm === "Mouth_Talk") {
            _jsonData2[i].layers[j].hd = true;
          } else if (_jsonData2[i].layers[j].nm === "Mouth_Static") {
            _jsonData2[i].layers[j].hd = false;
          }
        }
      }
    }

    for (let i = 0; i < _jsonData3.length - 1; i++) {
      if (_jsonData3[i].nm === "Mouth" || _jsonData3[i].nm === "mouth") {
        for (let j = 0; j <= _jsonData3[i].layers.length - 1; j++) {
          if (_jsonData3[i].layers[j].nm === "Mouth_Talk") {
            _jsonData3[i].layers[j].hd = true;
          } else if (_jsonData3[i].layers[j].nm === "Mouth_Static") {
            _jsonData3[i].layers[j].hd = false;
          }
        }
      }
    }

    // Lottie Player for a character
    //console.log("Lottie player from Stop Talking");
    //lottiePlayer(value);
  };

  useEffect(() => {
    // Count each item once (an item that reported twice used to make the counts never match).
    if (new Set(LoadCounter).size >= UnloadedCounter) {
      setTimeout(() => {
        setPreviewLoaded(false);

        // setPlay(true)
      }, 1200);
    }
  }, [LoadCounter]);

  // Safety net: the preview waits until every picture, character, prop, video and transition has
  // reported "loaded". One item that never reports (e.g. a picture that cannot be loaded) used to
  // leave the spinner on forever. After 20 s the preview opens anyway, and the console lists the
  // items that did not load.
  useEffect(() => {
    if (!Array.isArray(SlidesData) || SlidesData.length === 0) return;
    const timer = setTimeout(() => {
      let reported = [];
      try {
        reported = JSON.parse(sessionStorage.getItem("LoadCounter") || "[]");
      } catch (e) {}
      const missing = SlidesData.filter(
        (x) => x && x.isLoaded === false && !reported.includes(x.previewKey)
      );
      if (missing.length) {
        console.warn(
          "Preview: these items did not finish loading:",
          missing.map((x) => `${x.type} "${x.Name || x.AnimationId}" ${x.ImageSrc || x.character_FilePath || x.url || ""}`.slice(0, 300))
        );
      }
      setPreviewLoaded(false);
    }, 20000);
    return () => clearTimeout(timer);
  }, [SlidesData]);

  var style = { background: "#ffffff" };

  const checkScale = () => {
    if (CurrentProject.canvasSize === "1:1") {
      return "1.8";
    } else if (CurrentProject.canvasSize === "9:16") {
      return "3.2";
    } else {
      return "1";
    }
  };

  const [inputTickerVal, setinputTickerVal] = useState(0);

  const handlePlayerChange = (value) => {
    //commenting this because preview doesn't support this
    // mtrans(parseInt(value));
    // setTickerPosition(value);
    // setinputTickerVal(value);
  };

  const handleShowControls = (e) => {
    try {
      var mytimeout = null;
      var flag = false;
      if (document.getElementsByClassName("playerControlsWrapper").length > 0) {
        if (document.getElementById("playerControls").style.opacity !== "0") {
          clearInterval(mytimeout);
          mytimeout = setTimeout(function () {
            document.getElementById("playerControls").style.opacity = 0;
          }, 7000);
          flag = true;
        }
        if (flag == false) {
          document.getElementById("playerControls").style.opacity = 1;
        }

        if (!flag) {
          clearInterval(mytimeout);
        }
      }
    } catch (ex) {}
  };

  const makeFullScreen = () => {
    try {
      var element = document.getElementsByClassName("video-preview")[0];
      if (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
    } catch {}
  };

  return (
    <div
      className="preview-overlay"
      style={{ display: popupload ? "" : "none" }}
    >
      <div className="popupUpperDiv">
        <div
          ref={slideParent}
          className="Popupupper"
          style={{ position: "relative" }}
        >
          <div
            style={{ zIndex: 9999 }}
            className="closeIcon"
            onClick={() => {
              // let audioAvailable = false;
              // for (let i = 0; i < SupremeLayer.Layer.length; i++) {
              //     if(SupremeLayer.Layer[i].type === "audio"){
              //         audioAvailable = true;
              //         break;
              //     }
              // }
              // if(audioAvailable){
              //     setDestroyPopup(true)
              // }
              // else{
              //     // setPlay(false);
              //     setpopupload(false);
              // }
              // if (Ids !== null) {
              //     window.cancelAnimationFrame(Ids)
              //     Ids = null
              // }
              stopBgMusicWithPreview();
              const array = Array.from(SlidesData);
              repairVoiceAudio(array, authenticationData.ApiBaseURL);
              for (let i = 0; i < array.length; i++) {
                if (
                  array[i].type == "Character" &&
                  array[i].TTSName !== "" &&
                  array[i].Audio
                ) {
                  if (array[i].Audio) {
                    array[i].Audio.pause();
                  }
                }

                if (array[i].type === "audio") {
                  AudioStop(array[i]);
                }
              }

              //setSlidesData(array);
              setPlay(false);
              //Giving time to stop audios first
              setTimeout(() => {
                setcloseclick(true);
                setpopupload(false);
              }, 800);

              // setpopupload(false);
            }}
          >
            <span
              className="material-icons-round PbtnHvr"
              style={{
                color: "#fff",
                userSelect: "none",
              }}
            >
              close
            </span>
          </div>

          <div
            className="video-preview"
            //onMouseMoveCapture={(e) => handleShowControls(e)}
            style={{
              ...(ActiveBackground !== "" ? ActiveBackground : style),
              width: PopupWidthHeight.width,
              height: PopupWidthHeight.height,
              //border: "1px solid rgb(211 207 207)",
              //margin: "10px",
              overflow: "hidden",
            }}
          >
            {watermark.added &&
              watermark.enabled &&
              (watermark.position != "Pattern" ? (
                <div
                  className={
                    watermark.position == "Top Left"
                      ? "waterMarkPreview tl"
                      : watermark.position == "Top Right"
                      ? "waterMarkPreview tr"
                      : watermark.position == "Bottom Left"
                      ? "waterMarkPreview bl"
                      : watermark.position == "Bottom Right"
                      ? "waterMarkPreview br"
                      : watermark.position == "Center"
                      ? "waterMarkPreview cn"
                      : "waterMarkPreview"
                  }
                  style={{ opacity: watermark.opacity / 100 }}
                >
                  <img src={watermark.src} />
                </div>
              ) : (
                <div
                  style={{
                    opacity: watermark.opacity / 100,
                    backgroundImage: "url(" + watermark.pattern + ")",
                    zIndex: 9998,
                  }}
                  className="patternpreview"
                ></div>
              ))}

            {AnimatedBGData != "" && (
              <LottiePlayer
                loop
                path={AnimatedBGData}
                play
                style={{
                  width: "100%",
                  scale: checkScale(),
                  height: "100%",
                  position: "absolute",
                  zIndex: "-999px",
                }}
              />
            )}
            {PreviewLoaded && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "rgb(0 0 0 / 100%)",
                  zIndex: "9999999",
                  inset: "0px",
                  position: "relative",
                }}
              >
                <div
                  ref={AnimationRef}
                  style={{
                    width: "100px",
                    height: "100px",
                    position: "relative",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              </div>
            )}

            {SlidesData.length != 0 && OnePx && LayerManipulated && (
              <PreviewCanvas
                setpopupload={setpopupload}
                DestroyPopup={DestroyPopup}
                setDestroyPopup={setDestroyPopup}
                popupload={popupload}
                _unloadedCounter={_unloadedCounter}
                UnloadedCounter={UnloadedCounter}
                setUnloadedCounter={setUnloadedCounter}
                LoadCounter={LoadCounter}
                setLoadCounter={setLoadCounter}
                SlideTime={SlideTime}
                OnePx={OnePx}
                SlideData={SlideData}
                SupremeLayer={SupremeLayer}
                setSupremeLayer={setSupremeLayer}
                TickerRef={TickerRef}
                TickerStart={TickerStart}
                TickerPosition={TickerPosition}
                Play={!Play}
                SlidesData={SlidesData}
                setSlidesData={setSlidesData}
                slides={slides}
                isPlay={Play}
                EditorZoom={EditorZoom}
              />
            )}

            <div className="playerControlsWrapper" id="playerControls">
              {!Play && (
                <span
                  onClick={() => {
                    var array = Array.from(SlidesData);
                    repairVoiceAudio(array, authenticationData.ApiBaseURL);
                    for (let i = 0; i < array.length; i++) {
                      array[i].isPlaying = false;
                      if (array[i].Audio)
                        array[i].PauseTime = array[i].Audio.currentTime;
                      // startTalking(array[i].JSONValue);
                    }
                    setPlay(!Play);
                    // setSlidesData(array);
                  }}
                  className="material-icons-round previewPlayIcon"
                >
                  play_arrow
                </span>
              )}
              {Play && (
                <span
                  onClick={() => {
                    var array = Array.from(SlidesData);
                    repairVoiceAudio(array, authenticationData.ApiBaseURL);
                    for (let i = 0; i < array.length; i++) {
                      if (
                        array[i].type == "Character" &&
                        array[i].TTSName !== ""
                      ) {
                        if (array[i].Audio) {
                          if (!array[i].Audio.paused) array[i].Audio.pause();
                        }
                      }

                      array[i].isPlaying = false;
                      if (array[i].Audio)
                        array[i].PauseTime = array[i].Audio.currentTime;
                      // startTalking(array[i].JSONValue);
                    }

                    setPlay(!Play);
                    // setSlidesData(array);
                  }}
                  className="material-icons-round previewPlayIcon"
                >
                  pause
                </span>
              )}

              <InputRange
                ref={TickerRef}
                onMouseDown={() => {
                  setTickerStart(true);
                }}
                onMouseUp={(e) => {
                  setTickerStart(true);
                  ApplyBackground(parseInt(e.target.value));
                }}
                style={{
                  width: SliderWidth,
                  outline: 0,
                  zIndex: 3000,
                }}
                maxValue={Tl_TotalTime_Width ? Tl_TotalTime_Width : 100}
                minValue={0}
                step={1}
                id="customRange3"
                value={inputTickerVal}
                onChange={(value) => handlePlayerChange(value)}
              />
              <span className="previewTimerLabel">
                {calculateTimeByWidth(inputTickerVal) +
                  "/" +
                  msToTime(SupremeLayer.TotalTime)}
              </span>

              {CurrentProject.canvasSize === "16:9" && (
                <span
                  className="material-icons IconsPlayer"
                  onClick={(e) => {
                    makeFullScreen();
                  }}
                >
                  fullscreen
                </span>
              )}

              {/* <input
              ref={TickerRef}
              onMouseDown={() => {
                setTickerStart(true);
              }}
              onMouseUp={(e) => {
                setTickerStart(true);
                ApplyBackground(parseInt(e.target.value));
              }}
              onChange={(e) => {
                mtrans(parseInt(e.target.value));
                setTickerPosition(parseInt(e.target.value));
                
              }}
              style={{
                width: SliderWidth,
                outline: 0,
                zIndex: 3000,
              }}
              type="range"
              className="form-range"
              min="0"
              // max={SliderWidth ? SliderWidth : 100}
              max={Tl_TotalTime_Width ? Tl_TotalTime_Width : 100}
              step="1"
              id="customRange3"
              //    value={Play ? onplayticker : TickerPosition}
            /> */}
            </div>
          </div>

          {/* <input
            ref={TickerRef}
            onMouseDown={() => {
              setTickerStart(true);
            }}
            onMouseUp={(e) => {
              setTickerStart(true);
              ApplyBackground(parseInt(e.target.value));
            }}
            onChange={(e) => {
              mtrans(parseInt(e.target.value));
              setTickerPosition(parseInt(e.target.value));
            }}
            style={{
              width: SliderWidth,
              outline: 0,
              position: "absolute",
              bottom: "27px",
              left: "5%",
              height: "4px",
              zIndex: 999999,
            }}
            type="range"
            className="form-range"
            min="0"
            // max={SliderWidth ? SliderWidth : 100}
            max={Tl_TotalTime_Width ? Tl_TotalTime_Width : 100}
            step="1"
            id="customRange3"
            //    value={Play ? onplayticker : TickerPosition}
          />

          {!Play && (
            <span
              onClick={() => {
                var array = Array.from(SlidesData);
                repairVoiceAudio(array, authenticationData.ApiBaseURL);
                for (let i = 0; i < array.length; i++) {
                  array[i].isPlaying = false;
                  if (array[i].Audio)
                    array[i].PauseTime = array[i].Audio.currentTime;
                  // startTalking(array[i].JSONValue);
                }
                setPlay(!Play);
                // setSlidesData(array);
              }}
              className="material-icons-round PbtnHvr"
              style={{
                fontSize: "25px",
                color: "#0075ff",
                position: "absolute",
                bottom: "18px",
                left: "2%",
                cursor: "pointer",
                zIndex: 999999,
              }}
            >
              play_arrow
            </span>
          )}

          {Play && (
            <span
              onClick={() => {
                var array = Array.from(SlidesData);
                repairVoiceAudio(array, authenticationData.ApiBaseURL);
                for (let i = 0; i < array.length; i++) {
                  if (array[i].type == "Character" && array[i].TTSName !== "") {
                    if (array[i].Audio) {
                      if (!array[i].Audio.paused) array[i].Audio.pause();
                    }
                  }

                  array[i].isPlaying = false;
                  if (array[i].Audio)
                    array[i].PauseTime = array[i].Audio.currentTime;
                  // startTalking(array[i].JSONValue);
                }

                setPlay(!Play);
                // setSlidesData(array);
              }}
              className="material-icons-round PbtnHvr"
              style={{
                fontSize: "25px",
                color: "#0075ff",
                position: "absolute",
                bottom: "18px",
                left: "2%",
                cursor: "pointer",
                zIndex: 999999,
              }}
            >
              pause
            </span>
          )}

          <span
            style={{
              color: "#6a6a6a",
              fontWeight: "bold",
              position: "absolute",
              bottom: "2%",
              left: "85.5%",
              fontFamily: "sofia",
              zIndex: 999999,
            }}
            className="PbtnHvr"
          >
            {" "}
            {msToTime(SupremeLayer.TotalTime)} | Animatricks
          </span> */}

          {/* <svg
            onClick={() => {
              if (ScreenSize === "small") {
                setScreenSize("Large");
              } else {
                setScreenSize("small");
              }
            }}
            style={{
              width: "20px",
              position: "absolute",
              bottom: "2.1%",
              right: "1.5%",
              zIndex: 999999,
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 282.45 289"
          >
            {ScreenSize === "small" && (
              <>
                <path
                  fill="#0075ff"
                  d="M127,153l-3,1-10,10L16,263l-1-80s-.5-4.5-3.5-5.5-7-2-11,4v92a19.61,19.61,0,0,0,15,15h92s11-7,0-15h-81l108-109S139.5,153.5,127,153Z"
                />
                <path
                  fill="#0075ff"
                  d="M155.73,137.06l3-1,9.9-10.1L265.67,26l1.76,80s.55,4.5,3.56,5.47,7,1.93,11-4.11l-.88-92A19.63,19.63,0,0,0,265.92.5l-92,.88s-10.94,7.11.14,15l81-.77-106.95,110S143.22,136.68,155.73,137.06Z"
                />
              </>
            )}
            {ScreenSize !== "small" && (
              <>
                <path
                  fill="#0075ff"
                  d="M9,288.86l3-1,10-10,97.71-99.28,1.23,80s.51,4.49,3.52,5.49,7,2,11-4l-.26-92a19.61,19.61,0,0,0-15-15l-92,.27s-11,7,.05,15l81-.24L1.47,277.38S-3.49,288.4,9,288.86Z"
                />
                <path
                  fill="#0075ff"
                  d="M272.11.5l-3,1-9.89,10.11L162.41,111.79l-1.94-80s-.55-4.49-3.56-5.46-7-1.92-10.95,4.13l1.07,92a19.62,19.62,0,0,0,15.18,14.83l92-1.08s10.92-7.13-.18-15l-81,1L279.75,11.91S284.62.86,272.11.5Z"
                />
              </>
            )}
          </svg> */}
        </div>
      </div>
    </div>
  );
};
export default Preview;
